var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeFeatureThree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 686.06 418.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #564c54;\n      }\n\n      .cls-2 {\n        fill: #ea9b7a;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #dd615c;\n      }\n\n      .cls-5 {\n        opacity: .5;\n      }\n\n      .cls-6 {\n        fill: #084fc7;\n      }\n\n      .cls-7 {\n        fill: #d46a43;\n      }\n\n      .cls-8 {\n        fill: #585859;\n      }\n\n      .cls-9 {\n        fill: #d2dcec;\n      }\n\n      .cls-10 {\n        opacity: .8;\n      }\n\n      .cls-11 {\n        fill: #39393b;\n      }\n\n      .cls-12 {\n        fill: #21b573;\n      }\n\n      .cls-13 {\n        fill: #217c58;\n      }\n\n      .cls-14 {\n        fill: #ebb12b;\n      }\n\n      .cls-15 {\n        fill: none;\n      }\n\n      .cls-16 {\n        fill: #a92f4b;\n      }\n\n      .cls-17 {\n        fill: #124d93;\n      }\n\n      .cls-18 {\n        fill: #ced3e6;\n      }\n\n      .cls-19 {\n        fill: #243434;\n      }\n\n      .cls-20 {\n        fill: #0875f7;\n      }\n\n      .cls-21 {\n        fill: #c77e2e;\n      }\n\n      .cls-22 {\n        fill: #0463ef;\n      }\n\n      .cls-23 {\n        fill: #df615c;\n      }\n\n      .cls-24 {\n        fill: #faaf3a;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M355.11,123.54c-24.05-3.55-46.84-13.34-66.51-28.19-29.38-22.17-90.85-59.9-149.49-41.11-80.89,25.92-81.25,100.91-60.18,141.64,21.07,40.73,170.47,160.02,364.17,141.04,173.33-16.98,207.1-211.4,114.66-246.58-80.18-30.51-107.53,47.23-202.65,33.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 604.63,
    cy: 94.77,
    rx: 7.52,
    ry: 8.09
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M113.96,41.48c2.31-.42,4.64,.85,5.45,3.05,1.38,3.75-2.24,7.96-7.12,6.07h0c-4.21-3.12-2.38-8.38,1.67-9.12Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 584.11,
    cy: 22.47,
    r: 9.79,
    transform: "translate(155.2 419.61) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M143.64,33.76c1.47,5.26-1.59,10.72-6.85,12.19s-10.72-1.59-12.19-6.85c-1.47-5.26,1.59-10.72,6.85-12.19,5.26-1.47,10.72,1.59,12.19,6.85Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M534.94,328.41c2.19-.85,4.72-.03,5.92,1.98,2.06,3.43-.72,8.24-5.87,7.29h0c-4.72-2.28-3.89-7.79-.05-9.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M562.67,315.3c2.43,4.89,.43,10.83-4.47,13.25s-10.83,.43-13.25-4.47-.43-10.83,4.47-13.25c4.89-2.43,10.83-.43,13.25,4.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M571.69,7.48c0,3.33-2.7,6.02-6.02,6.02s-6.02-2.7-6.02-6.02,2.7-6.02,6.02-6.02,6.02,2.7,6.02,6.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M587.73,116.59c0-53.8-44.81-112.76-100.56-116.32-.98-.06-1.97-.12-2.97-.16-79.93-3.73-86.02,93.76-158.34,104.76-72.32,11-127.55-44.51-214.08-8.3C34.07,129.09,13.02,311.86,241.37,319.19c182.7,5.86,346.39-42.07,346.37-202.6Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 367.2,
    cy: 375.66,
    rx: 183.75,
    ry: 9.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M258.78,349.12h212c8.79,0,15.92,7.13,15.92,15.92v10.56H242.86v-10.56c0-8.79,7.13-15.92,15.92-15.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 319.9,
    y: 292.38,
    width: 88.39,
    height: 56.74
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "319.9 309.8 408.29 302.73 408.3 292.38 319.91 292.48 319.9 309.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M553.21,58.06v222.53c0,6.52-5.29,11.81-11.81,11.81H179.02c-6.52,0-11.81-5.29-11.81-11.81V58.06c0-6.52,5.29-11.81,11.81-11.81h362.38c.18,0,.35,0,.52,.01,.13,0,.26,.01,.38,.02h.01c.09,0,.18,.01,.27,.03,.15,.01,.3,.03,.46,.05,.1,.01,.2,.03,.3,.05,.05,0,.09,.01,.14,.02,.1,.01,.19,.03,.29,.06,5.38,1.1,9.43,5.86,9.43,11.57Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 364.05,
    cy: 276.41,
    r: 8.16,
    transform: "translate(-92.16 304.87) rotate(-40.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M543.78,46.49c-.1-.02-.19-.04-.29-.06-.05,0-.09-.02-.14-.02-.1-.02-.2-.04-.3-.05-.15-.02-.3-.04-.46-.05-.09-.01-.18-.02-.27-.03h-.01c-.13-.01-.25-.02-.38-.02-.17,0-.35-.01-.52-.01H179.02c-6.52,0-11.81,5.29-11.81,11.81v206.07h386V58.06c0-5.71-4.05-10.47-9.43-11.57Zm-5.88,197.06c0,1.78-1.44,3.21-3.21,3.21H185.74c-1.78,0-3.21-1.44-3.21-3.21V64.77c0-1.78,1.44-3.21,3.21-3.21h348.96c1.78,0,3.21,1.44,3.21,3.21V243.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 182.52,
    y: 61.56,
    width: 355.38,
    height: 185.2,
    rx: 3.21,
    ry: 3.21
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M537.9,64.77v16.87H182.52v-16.87c0-1.78,1.44-3.21,3.21-3.21h348.96c1.78,0,3.21,1.44,3.21,3.21Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M510.38,71.33c0,1.51-1.22,2.73-2.73,2.73s-2.73-1.22-2.73-2.73,1.22-2.73,2.73-2.73,2.73,1.22,2.73,2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M519.22,71.33c0,1.51-1.22,2.73-2.73,2.73s-2.73-1.22-2.73-2.73,1.22-2.73,2.73-2.73,2.73,1.22,2.73,2.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M215.99,68.44H493.84c1.34,0,2.43,1.09,2.43,2.43v.91c0,1.34-1.09,2.43-2.43,2.43H215.99c-1.34,0-2.43-1.09-2.43-2.43v-.91c0-1.34,1.09-2.43,2.43-2.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.35,71.33v2.67c0,.38-.41,.61-.74,.42l-2.31-1.34-2.31-1.34c-.33-.19-.33-.66,0-.85l2.31-1.34,2.31-1.34c.33-.19,.74,.05,.74,.42v2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.42,71.33v2.67c0,.38,.41,.61,.74,.42l2.31-1.34,2.31-1.34c.33-.19,.33-.66,0-.85l-2.31-1.34-2.31-1.34c-.33-.19-.74,.05-.74,.42v2.67Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M522.53,70.46h5.24c.36,0,.65,.29,.65,.65v.23c0,.36-.29,.65-.65,.65h-5.24c-.36,0-.65-.29-.65-.65v-.23c0-.36,.29-.65,.65-.65Z",
    transform: "translate(103.43 392.19) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M525.04,67.96h.23c.36,0,.65,.29,.65,.65v5.24c0,.36-.29,.65-.65,.65h-.23c-.36,0-.65-.29-.65-.65v-5.24c0-.36,.29-.65,.65-.65Z",
    transform: "translate(103.46 392.22) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 222.69,
    y: 85.71,
    width: 274.09,
    height: 153.85,
    rx: 6.42,
    ry: 6.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 231.84,
    y: 160,
    width: 69.48,
    height: 39,
    rx: 3.01,
    ry: 3.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 416.82,
    y: 94.87,
    width: 69.48,
    height: 39,
    rx: 3.01,
    ry: 3.01
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 231.74,
    y: 128,
    width: 69.58,
    height: 3.34,
    rx: 1.6,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 231.74,
    y: 113.88,
    width: 69.58,
    height: 3.34,
    rx: 1.6,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 231.74,
    y: 142.12,
    width: 69.58,
    height: 3.34,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 416.82,
    y: 161.09,
    width: 69.48,
    height: 3.34,
    rx: 1.6,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 416.82,
    y: 146.97,
    width: 69.48,
    height: 3.34,
    rx: 1.6,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 416.82,
    y: 175.22,
    width: 69.48,
    height: 3.34,
    rx: 1.6,
    ry: 1.6
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M222.69,215.67H496.78v22.47c0,.78-.64,1.42-1.42,1.42H224.12c-.79,0-1.42-.64-1.42-1.42v-22.47Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M477.13,224.53v-2.03h2.53v-1.8h-3.44c-.5,0-.9,.4-.9,.9v2.93h1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M477.13,228.13h-1.8v3.08c0,.5,.4,.9,.9,.9h3.44v-1.8h-2.53v-2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M484.94,224.53h1.8v-2.93c0-.5-.4-.9-.9-.9h-3.3v1.8h2.4v2.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M484.94,228.13v2.18h-2.4v1.8h3.3c.5,0,.9-.4,.9-.9v-3.08h-1.8Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 222.69,
    y: 211.18,
    width: 274.09,
    height: 4.49
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M242.61,90.41h3.09v6.77h4.14v2.4h-7.23v-9.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M250.69,90.41h3.09v9.17h-3.09v-9.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M265.07,90.41l-3.88,9.17h-3.04l-3.88-9.17h3.33l2.19,5.36,2.24-5.36h3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M273,97.24v2.33h-7.63v-9.17h7.46v2.33h-4.42v1.07h3.88v2.23h-3.88v1.21h4.59Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M237.52,94.92c0,2.08-1.69,3.77-3.77,3.77s-3.77-1.69-3.77-3.77,1.69-3.77,3.77-3.77,3.77,1.69,3.77,3.77Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M461.06,195.95c0,1.83-1.48,3.31-3.31,3.31s-3.31-1.48-3.31-3.31,1.48-3.31,3.31-3.31,3.31,1.48,3.31,3.31Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M463.94,204.33h-12.38s1.41-3.93,6.1-3.93c.03,0,.06,0,.09,0s.06,0,.09,0c4.69,0,6.1,3.93,6.1,3.93Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M475.37,193.94v2.08l-3.34,7.95h-3.7l3.18-7.41h-1.93v1.46h-2.79v-4.08h8.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M484.16,201.35v2.62h-8.04v-2.08l3.62-3.35c.69-.64,.79-1.03,.79-1.38,0-.49-.33-.79-.97-.79-.6,0-1.17,.33-1.48,.93l-2.55-1.27c.73-1.38,2.18-2.32,4.34-2.32,2.38,0,4.05,1.23,4.05,3.14,0,.99-.26,1.88-1.72,3.19l-1.43,1.3h3.38Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M233.2,211.48c-1.38,4.21-1.38,4.95-1.38,4.21l.05-120.39c0-.74-.05-.62-.05-87.79H502.54l.04,203.95H233.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M434.28,122.65s2.47,7.94,8.66,8.57c5,.5,8.91-4.78,10.23-6.83,.32-.49,.48-.79,.48-.79,0,0,.36-.01,.9-.1,1.26-.19,3.46-.76,4.12-2.44,.94-2.38-3.82-3.26-3.82-3.26,0,0,2.04-2.41,1.25-3.84-.78-1.41-3.96-1.28-3.96-1.28,0,0,3.06-2.66,1.67-4.41-2.1-2.63-5.14,1.01-5.4,1.22,.19-.28,8.04-12.22,5.54-12.7-2.18-.42-9.41,9.22-11.34,11.86-.31,.42-.48,.66-.48,.66,0,0-.15-.08-.41-.21-1.23-.6-4.98-2.13-6.93,.02-2.36,2.6-.52,13.54-.52,13.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M449.54,119.26c-.94,.75-1.72,1.69-1.9,2.56-.11,.56,.02,1.05,.39,1.42,.25,.26,.65,.46,1.13,.61,1.2,.39,2.88,.5,4.01,.53,.32-.49,.48-.79,.48-.79,0,0,.37-.01,.9-.1-.08-.05-.17-.07-.26-.07-1.79,.04-4.89-.16-5.59-.86-.09-.09-.19-.24-.13-.55,.2-.95,1.74-2.4,3.17-2.96,.23-.09,.35-.33,.29-.57-.06-.24-.3-.39-.54-.35-1.17,.19-4.43,.44-5.45-.59-.15-.15-.13-.24-.12-.29,.05-.23,.29-.49,.63-.76,.7-.55,1.83-1.12,2.67-1.45,.1-.04,.17-.1,.22-.18,.09-.13,.11-.29,.05-.44-.1-.25-.37-.37-.62-.27-.37,.15-1.68,.68-2.69,1.42-.36,.27-.69,.56-.91,.88-.14,.2-.24,.4-.29,.61-.06,.3-.05,.74,.38,1.17,.91,.91,2.72,1.07,4.18,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M444.89,112.29c.14,.14,.19,.34,.11,.53-.24,.58-.37,1.12-.31,1.51,.05,.31,.19,.42,.31,.47,.19,.09,.48,.12,.83,.11,.87-.03,2.13-.35,3.26-.71-.05,.08-.13,.14-.22,.18-.84,.33-1.97,.9-2.67,1.45-.11,.01-.23,.02-.34,.02-.35,.01-.67,0-.94-.07-.12-.03-.23-.07-.33-.11-.48-.22-.77-.64-.85-1.2-.09-.59,.07-1.31,.37-2.03,.13-.31,.52-.38,.76-.16,0,0,0,0,.01,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M436.32,113.89c.1,.07,1.67,1.09,3.41,1.66,.97,.31,1.99,.49,2.84,.27,.71-.17,1.24-.58,1.58-1.21,1.22-2.23-.43-4.7-1.53-5.97-.31,.42-.48,.66-.48,.66,0,0-.15-.08-.41-.21,.94,1.04,2.57,3.24,1.58,5.05-.21,.39-.53,.63-.97,.74-1.65,.41-4.53-1.16-5.5-1.8-.22-.15-.52-.09-.66,.14-.15,.22-.08,.52,.13,.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M441.23,126.77c.16,.05,.34,.02,.47-.1,.2-.18,.21-.48,.04-.68-.95-1.06-1.36-2.23-1.22-3.46,.36-3.16,4.14-5.83,4.18-5.86,.22-.15,.27-.45,.12-.67-.15-.22-.45-.27-.67-.12-.17,.12-4.17,2.95-4.59,6.53-.18,1.52,.32,2.93,1.46,4.21,.06,.07,.13,.11,.21,.14Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M381.42,87.39l4.87,12.32c.73,2.06,1.47,4.12,2.22,6.17,.74,2.05,1.49,4.09,2.25,6.12,.77,2.03,1.52,4.05,2.29,6.04,.77,1.99,1.57,3.96,2.37,5.87,.79,1.91,1.61,3.78,2.42,5.45,.4,.83,.81,1.6,1.15,2.21l.23,.4,.09,.16s.02,.04,.03,.07c.03,.08,.04,.13,.05,.17,.01,.08-.02,.13,.02,.2,.03,.08,.15,.18,.4,.3,.51,.23,1.61,.39,2.99,.33,1.38-.06,3.03-.34,4.74-.78,1.71-.44,3.52-1.01,5.34-1.7,3.64-1.38,7.37-3.13,11.05-5.09,3.69-1.95,6.4-3.52,9.99-5.76,1.15,5.32,4.91,9.62,10.36,11.67-3.49,3.18-7.15,6.13-11,8.94-3.87,2.79-7.93,5.43-12.4,7.76-2.24,1.16-4.57,2.27-7.1,3.22-2.53,.95-5.22,1.78-8.26,2.3-1.52,.26-3.13,.44-4.85,.47-1.72,.02-3.55-.09-5.47-.46-1.92-.37-3.93-1-5.87-1.96-1.94-.95-3.79-2.24-5.37-3.72-.79-.74-1.51-1.52-2.17-2.32l-.47-.6-.39-.52c-.13-.18-.24-.34-.36-.5-.11-.16-.24-.34-.34-.49-.86-1.27-1.57-2.43-2.23-3.57-1.31-2.26-2.42-4.41-3.5-6.55-1.06-2.14-2.05-4.26-3.01-6.38-.96-2.11-1.89-4.22-2.78-6.34-.89-2.11-1.77-4.22-2.63-6.34-.85-2.12-1.68-4.23-2.49-6.35-.8-2.12-1.6-4.25-2.38-6.38l-1.15-3.21-.56-1.62c-.19-.55-.37-1.07-.56-1.65l22.47-7.87Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M394.68,138.65c.19,0,.37-.08,.49-.25,.02-.03,2.37-3.14,4.41-4.6,.28-.2,.34-.58,.14-.86-.2-.28-.58-.34-.86-.14-2.2,1.57-4.58,4.73-4.68,4.86-.2,.27-.15,.66,.12,.86,.11,.08,.24,.12,.37,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M398.86,139.26s.09,0,.13-.01c.33-.07,.54-.4,.47-.73,0-.03-.57-2.64,0-4.61,.09-.33-.1-.67-.42-.76-.33-.09-.67,.1-.76,.42-.65,2.27-.04,5.1,0,5.22,.06,.29,.32,.48,.6,.48Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M393.16,204.93c-11.38,6.55-38.89,9.92-56.83,2.8-6.58-2.61-7.74-4.22-7.24-16.04,.02-.44,.04-.88,.06-1.32,.05-.93,.11-1.86,.18-2.78,.03-.45,.07-.89,.1-1.33,.13-1.65,.29-3.27,.47-4.82,.05-.43,.1-.85,.14-1.27,.41-3.46,1.07-6.57,1.67-8.98,.11-.43,.22-.85,.32-1.23,.64-2.36,1.15-3.78,1.15-3.78,2.89,.47,5.87,.74,8.87,.86,.42,.02,.85,.03,1.27,.04,15.52,.41,31.31-3.1,38.63-5.01,.44-.11,.85-.22,1.23-.33,1.9-.51,2.98-.84,2.98-.84,0,0,.67,1.17,1.61,3.11,.17,.36,.36,.74,.54,1.15,1.49,3.2,3.39,7.84,4.47,12.68,.02,.06,.03,.12,.04,.18,.09,.42,.18,.84,.27,1.26,.02,.08,.04,.17,.05,.25,.74,3.51,1.42,7.2,1.88,10.72h0c.06,.46,.11,.91,.17,1.35,.9,7.73,1.03,11.55-2.05,13.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M393.16,179.54s-.06-.03-.08-.04c-2.31-1.26-4.35-3.17-6.1-5.7-.24-.34-.47-.7-.7-1.07h0c-1.76-2.86-3.21-6.42-4.32-10.65,.44-.11,.85-.22,1.23-.33,1.09,4.18,2.51,7.66,4.24,10.42,.23,.37,.47,.72,.71,1.07,1.37,1.96,2.93,3.5,4.66,4.61,.02,.06,.03,.12,.04,.18,.09,.42,.18,.84,.27,1.26,.02,.08,.04,.17,.05,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M343.33,167.08c-.5,4.46-1.5,8.23-2.96,11.3-.19,.4-.39,.8-.61,1.17-1.2,2.17-2.67,3.94-4.4,5.3-2.12,1.66-4.28,2.41-6.03,2.73,.03-.45,.07-.89,.1-1.33,1.53-.32,3.37-1.01,5.17-2.42,1.5-1.17,2.78-2.69,3.85-4.53,.22-.38,.43-.77,.63-1.17,1.48-2.97,2.47-6.68,2.99-11.1,.42,.02,.85,.03,1.27,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M388.32,165.17c-.88,.39-1.82,.79-2.83,1.19-.39,.16-.79,.32-1.2,.48-5.86,2.29-13.53,4.64-21.81,5.49-.32,.03-.64,.06-.95,.09-7.51,.69-15.16,.37-21.46-.22-.45-.04-.89-.08-1.33-.13-2.66-.27-5.05-.58-7.03-.88,.11-.43,.22-.85,.32-1.23,2.04,.3,4.49,.62,7.23,.9,.43,.04,.87,.08,1.31,.12,6.42,.58,14.21,.87,21.78,.09,8.08-.83,15.57-3.12,21.32-5.35h0c.41-.16,.8-.32,1.19-.47,1.04-.42,2.01-.83,2.91-1.23,.17,.36,.36,.74,.54,1.15Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M405.99,258.99c-1.66-25.66-5.43-49.45-10.95-68.73l-30.51,14.21c.95,23.35,5.64,39.53,11.04,54.52h30.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M380.5,258.99c-8.85-25.25-10.4-45.91-10.42-46.18-.03-.35-.33-.61-.68-.59-.35,.02-.62,.33-.59,.68,.02,.26,1.57,20.85,10.35,46.09h1.34Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M358.46,258.99c1.88-18.23,4.05-40.62,4.33-49.29l-33.7-18.02s-5.94,20.5-2.04,67.3h31.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M355.37,258.99l5.65-46.68c.05-.4-.23-.76-.63-.8-.4-.05-.76,.23-.8,.63l-5.67,46.85h1.46Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M365.72,205.56c.04,.35,.36,.59,.7,.56t0,0c.35-.04,.6-.36,.56-.71-.28-2.37-.55-4.8-.81-7.22-.05-.43-.09-.85-.13-1.28-.82-7.94-1.49-15.75-1.93-21.28-.03-.45-.07-.88-.1-1.3-.1-1.21-.18-2.29-.25-3.2-.43,0-.85,0-1.28,0,.07,.91,.15,2,.25,3.22,.03,.42,.07,.85,.1,1.3,.44,5.48,1.1,13.22,1.92,21.11,.04,.44,.09,.87,.13,1.31,.27,2.52,.55,5.04,.84,7.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M362.54,197.58c.21,.06,1.16,.34,2.34,.49,.41,.06,.85,.1,1.29,.11,.41,.01,.81,0,1.21-.04,.77-.09,1.48-.29,2.04-.7,.7-.51,1.08-1.28,1.09-2.23,.05-2.5-.67-12.67-1.22-19.85-.03-.44-.06-.87-.1-1.29-.09-1.15-.17-2.19-.24-3.08-.42,.02-.85,.04-1.27,.05,.07,.89,.15,1.95,.24,3.12,.03,.42,.06,.85,.1,1.29,.54,7.17,1.26,17.32,1.21,19.74,0,.56-.19,.95-.57,1.23-.61,.44-1.61,.54-2.64,.49-.44-.02-.88-.07-1.29-.14-.76-.12-1.43-.28-1.84-.4-.34-.1-.69,.09-.79,.43-.1,.34,.09,.69,.43,.79Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M324.14,97.74l48.64-1.25c-1.51-2.11-1.37-22.27-2.04-26.43-.7-4.3-.16-12.81,.48-19.77,1.24-13.36-9.61-24.81-23.01-24.15-.2,0-.4,.02-.61,.03-20.45,1.3-21.95,18.82-20.05,29.43,1.73,9.66,2.95,35.99-3.41,42.14Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M334.68,161.88l3.92,16.45c9.8-.78,21.39-2.2,30.12-6.71,0,0,11.63,3.91,17.53,2.09l-4.32-11.82h-47.25Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M392.25,174.05c-11.3-.08-18.08-1.54-24.24-6.59-11.56,12.01-40.11,12.47-40.11,12.47,2.86-9.22,3.79-25.53,3.79-25.53-.23-1.69-.35-3.45-.53-5.24-.18-1.78-.42-3.59-.88-5.37-2.82-8.13-6.11-13.96-9.04-22.37-.19-.55-.38-1.09-.58-1.63-.13-.36-.26-.71-.39-1.06-.96-2.63-2-5.25-3.08-7.77-4.73-11.01-5.49-23.43,5.88-27.22,.83-.27,1.64-.54,2.43-.79,5.38-1.7,9.86-2.82,11.11-3.12,.23-.05,.34-.08,.34-.08l23.87,1.98,2.27,.19c3.34,.37,6.87,.28,9.1,.77,1.96,.43,3.15,.33,5.15,.92,4.7,1.39,4.57,7.72,6.03,15.58,.02,.13,.05,.27,.07,.41,.01,.04,.02,.09,.03,.13,.26,1.34,.56,2.66,.91,3.97,.39,1.46,.82,2.91,1.27,4.31,2.75,8.63,6.07,12.59,5.5,18.03-.52,4.92-5.53,11.63-6.86,13.06-.31,.33-.49,.51-.49,.51,0,.02,0,.05,.01,.08,.02,.19,.04,.4,.07,.62,.1,.83,.25,1.81,.43,2.93,.41,4.15,1,7.92,1.66,11.27,.36,1.81,.74,3.5,1.14,5.06,2.38,9.47,5.13,14.5,5.13,14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M387.12,159.55c-3.23,1.71-5.84,2.85-5.84,2.85l-2.41-4.54c2.31-.83,4.78-2.06,7.11-3.38,.53,1.41,1.02,2.83,1.14,5.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M335.04,155.29s10.86,4.61,18.9,5.39l-1.23,4.99s-13.17-2.17-18.44-5.93l.77-4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M385.75,138.36c.16,0,.32-.06,.45-.19,.29-.31,7.19-7.67,4.79-14.38-.67-1.86-1.44-3.75-2.27-5.74-2.5-6.06-5.33-12.92-6.05-21.82-.03-.34-.33-.59-.66-.56-.34,.03-.59,.32-.56,.66,.74,9.09,3.61,16.05,6.14,22.19,.82,1.98,1.59,3.85,2.25,5.69,2.15,6-4.45,13.05-4.52,13.12-.23,.25-.22,.63,.02,.87,.12,.11,.27,.17,.42,.17Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M365.7,112.13c0,.74-.6,1.34-1.34,1.34s-1.34-.6-1.34-1.34,.6-1.34,1.34-1.34,1.34,.6,1.34,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M367.69,124c0,.74-.6,1.34-1.34,1.34s-1.34-.6-1.34-1.34,.6-1.34,1.34-1.34,1.34,.6,1.34,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M368.89,136.06c0,.74-.6,1.34-1.34,1.34s-1.34-.6-1.34-1.34,.6-1.34,1.34-1.34,1.34,.6,1.34,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M369.4,148.47c0,.74-.6,1.34-1.34,1.34s-1.34-.6-1.34-1.34,.6-1.34,1.34-1.34,1.34,.6,1.34,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M369.34,161.37c0,.74-.6,1.34-1.34,1.34s-1.34-.6-1.34-1.34,.6-1.34,1.34-1.34,1.34,.6,1.34,1.34Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M358.07,81.71s5.18-.47,8.82,.5l-.39,13.62-3.1,.67,2.61,2.57-3.13,9.14s-4.28-15.2-4.81-26.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M336.95,79.75l-9.48,2.59,11.14,14.8,8.35-.67-2.93,6.39,18.86,5.32s-21.84-20.74-23.59-28.24l-2.34-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M338.6,80.86s5.45,11.6,24.28,27.32c0,0-1.01-12.37-4.8-25.63,0,0-11.08,3.86-19.48-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M365.51,117.9c-6.2,0-18.86-8.88-19.4-9.26-.23-.16-.28-.48-.12-.71,.16-.23,.48-.28,.71-.12,.13,.09,12.93,9.08,18.81,9.08s6.87-6.15,6.89-6.21c.05-.28,.32-.46,.6-.4,.28,.05,.46,.32,.4,.6-.01,.07-1.43,7.03-7.89,7.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M358.07,81.71l.25,3.22c.48,5.99-3.79,7.69-9.99,4.52-4.9-2.51-9.06-6.25-9.74-8.57l19.47,.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M349.19,142.89c.1,.18,.29,.28,.48,.28,.09,0,.19-.02,.27-.07,.09-.05,9.05-5.1,19.99-2.96,5.56,1.08,10.28,.97,13.95,.15-.03-.22-.05-.42-.07-.62,0-.03,0-.05,0-.08,0,0,.18-.18,.49-.5-3.59,.91-8.39,1.09-14.15-.04-11.36-2.22-20.37,2.87-20.75,3.09-.26,.15-.36,.49-.2,.75Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M368.33,40.75s2.75,10.81,.99,12.69c-1.76,1.89-4.37-2.16-4.37-2.16,0,0,1.28-10.1,3.38-10.53Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M365.29,55.06s2.85-3.36,4.45,0,.37,10.17-3.96,9.06l-.49-9.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M362.8,63.42c-1.58,.74-2.68,2.34-2.68,4.2,0,2.56,2.08,4.64,4.64,4.64s4.64-2.08,4.64-4.64c0-1.84-1.07-3.43-2.62-4.18-.53-.26-1.12-.42-1.74-.45-.11-.29-.21-.58-.33-.86,.02,0,.04,0,.05,0,.76,0,1.49,.16,2.14,.44,1.96,.84,3.35,2.79,3.35,5.05,0,3.03-2.46,5.49-5.49,5.49s-5.49-2.46-5.49-5.49c0-2.04,1.12-3.82,2.77-4.77l.77,.56Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M358.1,72.32v9.27s-4.89,8.01-19.48-1.69c2.76-3.09,2.85-9.05,1.73-12.61,0,0,1.07,.72,2.84,1.51,.36,.16,.75,.33,1.16,.5,3.65,1.53,9.13,3.37,13.75,3.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M358.1,72.32v4.34c-3.97-.88-10.92-3.05-14.91-7.86,.36,.16,.75,.33,1.16,.5,3.65,1.53,9.13,3.37,13.75,3.01Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M366.03,69.28c-7.79,8.06-25.08-1.56-25.64-1.87,0,0-.01,0-.01,0-.16-.72-.3-1.44-.43-2.14-1.1-5.99-1.17-11.56-.56-16.85-.29-5.58,3.03-10.77,8.28-12.69,5.44-1.98,10.32,.41,13.25,1.31,4.42,1.36,7.21,7.08,7.23,15.23,.03,10-.17,15.03-2.11,17.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M367.21,42.96c-1.8,.25-3.65,.44-5.55,.59l-1.04-4.98-.34,5.08c-3.5,.24-7.13,.33-10.86,.33l-.46-5.24-1.02,5.24c-2.76-.01-5.56-.07-8.38-.15-2.26-10.45,9.07-15,18.6-12.83,9.53,2.17,9.06,11.95,9.06,11.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M346.79,40.75s-3.51,4.68-1.59,9.03c1.92,4.35,.58,8.61-.33,11.78,0,0-1.99-7-6.68-8.3s-2.26-14.13,8.6-12.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M359.35,64.88c1.03,.16,1.86-.12,1.91-.14,.17-.06,.27-.25,.21-.42-.06-.17-.25-.27-.42-.21h0s-1.63,.53-2.97-.45c-.15-.11-.36-.08-.47,.07-.11,.15-.08,.36,.07,.46,.55,.4,1.14,.6,1.67,.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M364.3,59.67s-5.42,1.89-9.49-.79c0,0,1.43,3.66,4.94,4.01,3.51,.35,4.55-3.22,4.55-3.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M355.67,44.85s1.62,.16,1.05,1.64c-.57,1.48-3.81-.15-6.13,2.58,0,0-.99-3.56,5.08-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M363,44.85s-1.62,.16-1.05,1.64c.57,1.48,3.81-.15,6.13,2.58,0,0,.99-3.56-5.08-4.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M354.79,55.83c0,.75-1.55,1.37-3.47,1.37s-3.47-.61-3.47-1.37,1.55-1.37,3.47-1.37,3.47,.61,3.47,1.37Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M368.93,57.16c-.27,.03-.55,.04-.84,.04-1.92,0-3.47-.61-3.47-1.37s1.55-1.37,3.47-1.37c.26,0,.51,.01,.75,.03l.08,2.66Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M355.19,52.25c0,1.04-.47,1.88-1.05,1.88s-1.05-.84-1.05-1.88,.47-1.88,1.05-1.88,1.05,.84,1.05,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M365.44,52.25c0,1.04-.47,1.88-1.05,1.88s-1.05-.84-1.05-1.88,.47-1.88,1.05-1.88,1.05,.84,1.05,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M361.42,56.21c.5,0,.83-.08,.86-.09,.12-.03,.21-.11,.27-.21,.06-.11,.07-.23,.03-.34l-1.58-4.52c-.08-.22-.32-.34-.54-.26-.22,.08-.34,.32-.26,.54l1.4,4.02c-.43,.02-1.09-.02-1.75-.38-.21-.11-.47-.03-.58,.17-.11,.21-.03,.47,.17,.58,.72,.39,1.44,.48,1.97,.48Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M343.76,63.21c-.05,.12-1.41,3.28-3.37,4.2,0,0,0,0,0,0,0,0-.01-.01-.01-.01-.16-.72-.3-1.44-.43-2.14,.07-.01,2.05-.36,3.82-2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M341.87,56.01s-4.14-5.56-7.18-1.19c-2.5,3.6,2.21,13.2,7.27,9.69l-.09-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M337.57,64.58c-1.58,.74-2.68,2.37-2.68,4.22,0,2.56,2.08,4.64,4.64,4.64s4.64-2.08,4.64-4.64c0-1.84-1.07-3.43-2.62-4.18-.53-.26-1.12-.42-1.74-.45-.11-.29-.21-.58-.33-.86,.02,0,.04,0,.05,0,.76,0,1.49,.16,2.14,.44,1.96,.84,3.35,2.79,3.35,5.05,0,3.03-2.46,5.49-5.49,5.49s-5.49-2.46-5.49-5.49c0-2.04,1.15-3.85,2.8-4.8,.24,.21,.48,.41,.73,.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M341.3,62.92s.03,0,.05,0c.23-.03,.4-.24,.38-.47-.52-4.73-4.5-6.37-4.67-6.44-.22-.09-.47,.02-.55,.24-.09,.22,.02,.47,.24,.55,.16,.06,3.68,1.53,4.14,5.74,.02,.22,.21,.38,.42,.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M337.32,60.34c.09,0,.19-.03,.27-.1h0c.37-.3,1.49-1.04,2.23-.85,.23,.06,.46-.08,.52-.31,.06-.23-.08-.46-.31-.52-1.28-.33-2.81,.88-2.98,1.01-.18,.15-.21,.42-.06,.6,.08,.1,.21,.16,.33,.16Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M309.03,144.06s1.36,2.94-.21,9.35c-1.57,6.42-4.2,10.44-4.2,10.44,0,0-6.58-9.99,4.41-19.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.99,137.93c.02,.32,.04,.65,.07,.96,.04,.32,.09,.63,.14,.95,.03,.15,.05,.31,.09,.47l.11,.45c.28,1.22,.72,2.31,1.2,3.31,.24,.48,.51,.97,.77,1.39,.14,.21,.27,.43,.41,.64l.42,.59c1.14,1.55,2.35,2.71,3.52,3.7,1.18,.99,2.35,1.8,3.49,2.53,.57,.37,1.14,.7,1.71,1.03s1.12,.63,1.68,.93c1.12,.58,2.22,1.13,3.32,1.63,2.2,1.01,4.38,1.86,6.56,2.63,2.17,.77,4.35,1.46,6.51,2.09,2.17,.64,4.33,1.22,6.5,1.75,2.17,.53,4.34,1.01,6.53,1.47,.79,.16,1.88,.27,3.02,.36,1.74,.13,3.63,.23,4.87,.44,.3-1.8-1.22-3.25-.92-5.05,.35-2.1,.7-4.21,1.08-6.31l-.87-1.88c-1.32-.32-2.64-.66-3.97-1.02-.04-.01-.08-.02-.12-.03-1.93-.52-3.84-1.1-5.74-1.72-1.93-.62-3.85-1.29-5.74-2-1.88-.71-3.72-1.47-5.51-2.28-1.78-.81-3.52-1.66-5.13-2.57-.8-.45-1.59-.91-2.31-1.4-.36-.24-.72-.48-1.05-.73-.33-.25-.65-.5-.95-.75-.46-.38-.88-.78-1.22-1.15-.1-.11-.19-.21-.28-.32v-.02s.29-.42,.29-.42l.56-.76c.29-.4,.57-.79,.89-1.2,.62-.81,1.22-1.61,1.85-2.42l1.91-2.42c1.3-1.61,2.59-3.24,3.92-4.85l.99-1.21,1-1.21,1.41-1.7,.6-.72,.73-.88,1.29-1.55,2.04-2.42c1.35-1.61,2.71-3.23,4.08-4.83l8.17-9.64,.05-.06c3.44-4.06,2.94-10.15-1.12-13.59-4.03-3.41-10.04-2.94-13.5,1.02l-2.14,2.46-2.1,2.46c-.7,.82-1.39,1.65-2.08,2.47-.69,.82-1.39,1.65-2.07,2.48-1.37,1.66-2.74,3.33-4.1,5.01l-2.03,2.53-.27,.34-1.75,2.21c-.67,.85-1.34,1.71-2,2.56l-1,1.29-.45,.59-.54,.71c-1.32,1.73-2.63,3.48-3.93,5.25l-1.94,2.69c-.64,.9-1.28,1.84-1.92,2.76-.32,.45-.64,.93-.96,1.42l-.95,1.44-.24,.36-.06,.09-.03,.05-.05,.07-.2,.32c-.13,.22-.26,.43-.39,.65-.06,.11-.13,.23-.19,.35l-.18,.36c-.12,.24-.24,.47-.36,.72-.11,.26-.22,.52-.32,.78l-.15,.4c-.05,.13-.1,.28-.14,.42-.09,.28-.18,.57-.26,.85-.08,.29-.14,.6-.21,.9-.06,.3-.13,.6-.17,.92-.04,.32-.08,.63-.11,.95-.03,.32-.04,.64-.05,.97v.48c0,.16,0,.32,.01,.49Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M322.16,149.81s-1.56-1.52-3.48-1.13c0,0-4.54,7.69-2.18,14.29,0,0,1.05,.95,3.26,.77,0,0-2.2-7.93,2.41-13.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.35,156.52c.14,2.53,2.31,4.46,4.83,4.32,2.53-.14,4.46-2.31,4.32-4.83-.14-2.53-2.31-4.46-4.83-4.32-2.53,.14-4.46,2.31-4.32,4.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M318.12,159.69c1.89-.11,3.34-1.73,3.23-3.61s-1.73-3.34-3.61-3.23c-1.89,.11-3.34,1.73-3.23,3.61s1.73,3.34,3.61,3.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M326.03,164.57c1.74,.13,3.63,.23,4.87,.44,.3-1.8-1.22-3.25-.92-5.05,.35-2.1,.7-4.21,1.08-6.31l-.87-1.88c-1.32-.32-2.64-.66-3.97-1.02-.04-.01-.08-.02-.12-.03-.54,2.99-1.38,9.25-.07,13.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M330.3,92.89c.93,3,.22,6.28-1.84,8.65-3.86,4.46-11.24,13.08-15.33,18.49-5.72,7.56-12.94,17.05-12.94,17.05,0,0,5.2,4.57,8.85,6.98,0,0-8.92,7.54-4.41,19.79,0,0-16.03-8.81-24.14-17.27-5.92-6.18-4.28-13.89,1.13-21.27,2.73-3.72,23.8-27.73,31.28-36.13,2.76-3.1,7.12-4.34,11.04-2.99,2.51,.87,5.16,2.74,6.37,6.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M326.39,153s.63-3.67,1.58-7.19c.79-2.94,2.39-3.85,2.39-3.85,.35,2,.84,3.21,.9,6.85,0,0,.89-.83,2.51-.5,1.62,.33,7.2,1.51,7.28,2.8,.16,2.95-6.83,1.55-6.83,1.55,0,0,7.49,1.41,7.3,3.48-.15,1.67-6.93,1.99-6.93,1.99,0,0,6.54,.06,5.75,2.41-.83,2.49-6.9,.92-6.9,.92,0,0,4.37,2.1,3.95,2.98-.61,1.27-3.2,1.62-7.38,.6-4.28-1.04-3.61-12.03-3.61-12.03Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M318.67,114.63c-.16,.02-.33-.02-.46-.13-.24-.21-.28-.57-.07-.81l9.68-11.49c.21-.24,.57-.28,.81-.07,.24,.21,.28,.57,.07,.81l-9.68,11.49c-.09,.11-.22,.18-.35,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M329.2,106.12l-3.66,.56c-.32,.05-.61-.17-.66-.48-.05-.32,.17-.61,.48-.66l3.66-.56c.32-.05,.61,.17,.66,.48,.05,.32-.17,.61-.48,.66Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M289.81,139.57c.06,.08,.14,.13,.23,.14,.1,.02,.21,0,.29-.07,2.76-2.05,7.67-2.27,10.1-2.24-.1-.11-.19-.21-.28-.32l-.02-.02,.31-.43c-.22,0-.46,0-.72,0-1.52-1.46-5.62-2.88-5.8-2.94-.2-.07-.41,.04-.48,.23-.07,.2,.04,.41,.23,.48,.04,.01,3.16,1.09,4.88,2.26-2.68,.12-6.34,.62-8.68,2.37-.17,.12-.2,.36-.08,.53Z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 135.59,
    cy: 410.66,
    rx: 127.36,
    ry: 7.77
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.53,167.53l.16,.76,.12,.61,.21,1.15c.13,.75,.25,1.48,.36,2.21,.21,1.46,.39,2.89,.55,4.32,.31,2.86,.54,5.69,.67,8.53,.13,2.83,.17,5.66,.14,8.49-.04,2.83-.16,5.65-.35,8.47-.2,2.82-.49,5.64-.84,8.45-.2,1.4-.38,2.81-.61,4.21-.11,.7-.22,1.4-.34,2.1l-.39,2.09c-.12,.7-.28,1.39-.42,2.09-.15,.69-.28,1.39-.45,2.08-.32,1.38-.63,2.77-1,4.15-.18,.69-.35,1.38-.54,2.06l-.58,2.06-.15,.51-.07,.26-.15,.52c-.15,.49-.3,.91-.47,1.34-.16,.4-.33,.81-.5,1.17-.17,.38-.35,.71-.53,1.05l-.26,.47c-.09,.16-.18,.31-.27,.45l-.27,.44-.26,.41c-.18,.28-.35,.52-.53,.77-.7,.98-1.39,1.8-2.06,2.55-.67,.75-1.32,1.41-1.97,2.03-1.29,1.24-2.54,2.29-3.77,3.28-2.46,1.96-4.87,3.61-7.28,5.15-4.8,3.07-9.57,5.72-14.37,8.21-4.79,2.49-9.61,4.79-14.45,6.99-2.43,1.09-4.86,2.16-7.3,3.2-1.22,.52-2.44,1.04-3.67,1.55l-1.86,.75-1.91,.76-8.38-18.94,1.63-.83,1.67-.87,3.35-1.75c2.23-1.18,4.46-2.37,6.66-3.59,4.42-2.41,8.79-4.9,13.04-7.44,2.12-1.27,4.21-2.58,6.25-3.89,2.04-1.31,4.03-2.65,5.91-4.01,1.88-1.36,3.67-2.74,5.19-4.08,.76-.67,1.45-1.33,2-1.91,.54-.58,.95-1.12,1.03-1.3,0-.01,.02-.04,0-.04,0,0,0,0,0,0,0,0-.01,.01-.02,.02l-.03,.03s-.02,.03-.03,.05c-.04,.05-.05,.09-.1,.18-.03,.07-.09,.17-.13,.28-.06,.13-.1,.25-.16,.43l-.04,.12s0,0,0-.01v-.05s.06-.21,.06-.21l.1-.43,.39-1.7c.13-.57,.24-1.14,.36-1.71,.25-1.14,.44-2.29,.65-3.44,.11-.57,.19-1.15,.28-1.73,.09-.58,.19-1.15,.26-1.73,.34-2.31,.6-4.64,.81-6.98,.2-2.34,.33-4.68,.43-7.03,.08-2.35,.1-4.7,.06-7.04-.03-2.35-.13-4.69-.29-7.03-.15-2.33-.36-4.65-.64-6.94-.14-1.14-.3-2.27-.47-3.37-.08-.55-.17-1.09-.26-1.62l-.14-.76-.11-.54,26.07-5.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M125.67,173.98l-4.76,36.1c7.11,3.98,13.85,6.83,20.05,7.96l-15.28-44.06Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M135.77,229.78c-.1,0-.21-.02-.3-.08-3.7-2.01-8.79-3.7-8.84-3.72-.33-.11-.51-.47-.4-.8,.11-.33,.47-.51,.8-.4,.21,.07,5.25,1.74,9.05,3.81,.31,.17,.42,.55,.25,.86-.11,.21-.33,.33-.56,.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M127.18,226.14c-.32,0-.59-.24-.63-.56-.04-.35,.21-.66,.56-.7,2.63-.29,6.08-.31,6.22-.31h0c.35,0,.63,.28,.63,.63,0,.35-.28,.63-.63,.64-.04,0-3.53,.02-6.09,.3-.02,0-.05,0-.07,0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "58.71 374.35 52.14 385.07 39.64 379.54 45.31 368.01 58.71 374.35"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M.02,385.63l47.31,20.94c.63-.48,1.23-1.31,1.79-2.35,2.07-3.87,3.62-10.82,4.78-15.13,.13-.5,.26-.97,.39-1.39,.21-.71,.41-1.3,.59-1.71,1.45-3.29-1.7-4.01-1.7-4.01-6.87,2.58-9.17-6.86-13.36-5.96,0,0-1.8,.37-7.05,2.09-5.25,1.72-12.63,1.12-19.07,.99-8.32-.17-11.61,1.88-12.89,3.72-1.02,1.46-.77,2.8-.77,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M.02,385.63l47.31,20.94c.63-.48,1.23-1.31,1.79-2.35L.8,382.83c-1.02,1.46-.77,2.8-.77,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M42.51,404.43l1.41,.62c-.69-2.22-.92-5.26,.81-8.7,2.3-4.57,6.5-6.48,9.17-7.26,.13-.5,.26-.97,.39-1.39-2.81,.68-7.91,2.62-10.66,8.1-1.65,3.28-1.66,6.28-1.11,8.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.33,381.26c.35,.15,.77,.06,1.02-.26,.29-.37,.22-.91-.15-1.2l-2.63-2.04c-.37-.29-.91-.22-1.2,.15-.29,.37-.22,.91,.15,1.2l2.63,2.04c.06,.04,.12,.08,.18,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.35,380.1c.35,.15,.77,.06,1.02-.26,.29-.37,.22-.91-.15-1.2l-2.63-2.04c-.37-.29-.91-.22-1.2,.15-.29,.37-.22,.91,.15,1.2l2.63,2.04c.06,.04,.12,.08,.18,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.61,381.67c.35,.15,.77,.06,1.02-.26,.29-.37,.22-.91-.15-1.2l-2.63-2.04c-.37-.29-.91-.22-1.2,.15-.29,.37-.22,.91,.15,1.2l2.63,2.04c.06,.04,.12,.08,.18,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.92,382.02c.35,.15,.77,.06,1.02-.26,.29-.37,.22-.91-.15-1.2l-2.63-2.04c-.37-.29-.91-.22-1.2,.15-.29,.37-.22,.91,.15,1.2l2.63,2.04c.06,.04,.12,.08,.18,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.03,382.12c.35,.15,.77,.06,1.02-.26,.29-.37,.22-.91-.15-1.2l-2.63-2.04c-.37-.29-.91-.22-1.2,.15-.29,.37-.22,.91,.15,1.2l2.63,2.04c.06,.04,.12,.08,.18,.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.96,381.87c.35,.15,.77,.06,1.02-.26,.29-.37,.22-.91-.15-1.2l-2.63-2.04c-.37-.29-.91-.22-1.2,.15-.29,.37-.22,.91,.15,1.2l2.63,2.04c.06,.04,.12,.08,.18,.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M88.08,270.88c4.39-4.32,39.03-13.98,62.03-7.56,2.64,5.07,5.99,17.92-2.25,29.81-30.23,4.94-47.1,15.11-47.1,15.11,0,0-10.72,24.77-17.09,33.86-6.37,9.09-20.98,37.96-20.98,37.96l-22.01-9.4s35.45-88.02,47.4-99.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M65.04,374.62c-.08,0-.16-.02-.24-.05l-21.54-8.95c-.32-.13-.48-.5-.34-.83,.13-.32,.5-.48,.83-.34l21.54,8.95c.32,.13,.48,.51,.34,.83-.1,.24-.34,.39-.59,.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M61.42,372.81c-.08,0-.16-.01-.23-.04-.33-.13-.48-.5-.36-.82,.04-.11,4.55-11.36,15.06-27.31,10.44-15.84,21.36-42.63,21.47-42.9,.13-.32,.5-.48,.83-.35,.32,.13,.48,.5,.35,.83-.11,.27-11.07,27.17-21.58,43.12-10.44,15.84-14.9,26.97-14.94,27.08-.1,.25-.34,.4-.59,.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.26 376.24 112.59 388.7 98.92 388.7 99.44 375.87 114.26 376.24"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M65.16,410.31h51.74c.38-.7,.59-1.69,.68-2.87,.32-4.38-1.07-11.36-1.76-15.76-.08-.51-.15-.99-.21-1.43-.1-.74-.15-1.35-.15-1.8,0-3.59-3.18-2.98-3.18-2.98-5.24,5.13-11.16-2.57-14.62-.04,0,0-1.49,1.07-5.6,4.76-4.11,3.7-11.09,6.13-17.04,8.62-7.68,3.21-9.85,6.41-10.28,8.62-.34,1.75,.43,2.87,.43,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M65.16,410.31h51.74c.38-.7,.59-1.69,.68-2.87h-52.84c-.34,1.75,.43,2.87,.43,2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M111.62,410.31h1.54c-1.53-1.75-2.97-4.44-2.78-8.28,.25-5.11,3.32-8.56,5.45-10.35-.08-.51-.15-.99-.21-1.43-2.3,1.76-6.17,5.6-6.47,11.72-.18,3.67,1.03,6.41,2.48,8.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.93,393.24c.38,0,.73-.26,.83-.65,.11-.46-.16-.92-.62-1.03l-3.23-.8c-.46-.11-.92,.16-1.03,.62-.11,.46,.17,.92,.62,1.03l3.23,.8c.07,.02,.14,.03,.21,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.14,390.55c.38,0,.73-.26,.83-.65,.11-.46-.16-.92-.62-1.03l-3.23-.8c-.46-.11-.92,.16-1.03,.62-.11,.46,.16,.92,.62,1.03l3.23,.8c.07,.02,.14,.03,.21,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.7,395.12c.38,0,.73-.26,.83-.65,.11-.46-.16-.92-.62-1.03l-3.23-.8c-.46-.11-.92,.16-1.03,.62-.11,.46,.16,.92,.62,1.03l3.23,.8c.07,.02,.14,.03,.21,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.47,396.92c.38,0,.73-.26,.83-.65,.11-.46-.16-.92-.62-1.03l-3.23-.8c-.46-.11-.92,.17-1.03,.62-.11,.46,.17,.92,.62,1.03l3.23,.8c.07,.02,.14,.03,.21,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M82.94,398.59c.38,0,.73-.26,.83-.65,.11-.46-.16-.92-.62-1.03l-3.23-.8c-.46-.11-.92,.16-1.03,.62s.17,.92,.62,1.03l3.23,.8c.07,.02,.14,.03,.21,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79.12,400.02c.38,0,.73-.26,.83-.65,.11-.46-.16-.92-.62-1.03l-3.23-.8c-.46-.11-.92,.16-1.03,.62-.11,.46,.16,.92,.62,1.03l3.23,.8c.07,.02,.14,.03,.21,.03Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M217.91,273.13c-.02,.21-.05,.41-.07,.6-.11,.08-.21,.16-.31,.24-8.03,6.16-17.4,10.26-26.97,12.59-.34,.08-.67,.16-1.01,.24-1.64,.38-3.29,.71-4.94,.98-2.23,.37-4.46,.66-6.67,.85-1.96,.17-3.91,.28-5.83,.31-8.28,.15-16.13-.93-22.77-3.04-.25-.08-.51-.16-.76-.25-1.76-.59-3.42-1.25-4.98-1.98-.24-.11-.48-.22-.71-.34-.97-.47-1.9-.98-2.78-1.51,.14-3.19,.18-7.01,.15-11.09,0-.34,0-.68,0-1.02-.06-5.68-.23-11.81-.45-17.41-.02-.27-.03-.53-.03-.79-.12-2.93-.26-5.71-.38-8.18-.02-.26-.03-.53-.04-.78-.11-2.09-.22-3.96-.32-5.49-.03-.39-.05-.77-.08-1.16-.02-.3-.04-.6-.06-.89h0c-.08-1.08-.17-2.14-.26-3.18-.14-1.66-.3-3.27-.47-4.83-.2-1.78-.41-3.52-.63-5.19-.25-1.8-.5-3.53-.77-5.21-.29-1.79-.59-3.51-.91-5.16-1.11-5.82-2.36-10.82-3.61-15.14-.09-.3-.17-.58-.26-.88-.51-1.72-1.01-3.31-1.5-4.81-.11-.33-.22-.65-.32-.98-2.78-8.25-5.08-13.23-5.12-16.57-.08-6.95,5-9.18,10.3-11.98,.25-.13,.5-.26,.75-.4,.89-.48,1.79-.99,2.65-1.54,.37-.23,.73-.47,1.08-.72,.25-.17,.48-.35,.71-.52,2.1-1.62,3.94-3.65,5.14-6.53l20.03-4.22s1.92,.99,5.13,1.85c.3,.08,.61,.16,.94,.24,.38,.09,.77,.18,1.18,.26,.25,.05,.52,.1,.78,.15,.2,.04,.41,.08,.62,.11,1.92,.3,4.14,.49,6.65,.44,.25,0,.51-.01,.76-.02,.18,0,.36-.02,.54-.02,1.7-.09,3.32,.13,4.88,.63h0c.3,.09,.59,.2,.88,.32,6.51,2.6,11.63,10.38,14.94,22.33,.92,3.32,1.83,6.56,2.71,9.72,.1,.35,.19,.69,.29,1.03,.19,.69,.38,1.38,.57,2.07h0c.07,.25,.14,.5,.21,.75,.68,2.45,1.34,4.87,1.98,7.26h0c.07,.26,.14,.51,.2,.77t0,0c.04,.14,.07,.27,.11,.4l.36,1.4c2.22,8.55,4.07,16.79,5.26,25.1,.25,1.73,.47,3.46,.65,5.2,.05,.42,.1,.9,.15,1.42,.01,.1,.02,.19,.03,.29,.02,.18,.04,.36,.06,.55,0,.09,.02,.19,.03,.28,.32,3.15,.73,7.51,1.14,12.32,.02,.25,.05,.51,.07,.77,.93,11.2,1.76,24.52,1.1,30.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M156.95,163.15c8-1.69,12.32-11.69,12.5-12.13,.12-.29-.01-.63-.3-.75-.29-.12-.63,.01-.75,.3-.04,.1-4.43,10.29-12.15,11.54-7.59,1.23-10.61-4.35-10.74-4.59-.15-.28-.49-.39-.77-.24-.28,.15-.39,.49-.24,.77,.03,.07,3.51,6.56,11.94,5.19,.17-.03,.34-.06,.51-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M165.07,269.59c7.52-1.59,15.29-5.45,23.06-11.52,10.66-8.33,17.66-17.99,17.73-18.09,.18-.26,.13-.61-.13-.8-.26-.18-.62-.13-.8,.13-.07,.1-6.99,9.64-17.52,17.87-9.66,7.55-24.44,15.51-39.96,10.55-.3-.1-.62,.07-.72,.37-.1,.3,.07,.62,.37,.72,5.73,1.83,11.77,2.07,17.98,.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M160.57,263.85s0,0,0,0c11.71-2.67,18-20.35,18.27-21.1,.1-.3-.05-.62-.35-.73-.3-.1-.62,.05-.73,.35-.06,.18-6.35,17.83-17.44,20.36-.31,.07-.5,.38-.43,.69,.07,.31,.37,.5,.68,.43Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M138.93,235.89c1.45-1,2.82-2.24,3.9-3.65,2.61-3.4,2.96-6.88,.99-9.8-.4-.58-.76-1.11-1.1-1.61-4.03-5.88-4.45-6.49-4.1-16.16,.11-3.04-.75-5.44-2.55-7.1-1.21-1.13-2.69-1.78-4.11-2.16,.09,.29,.17,.58,.26,.88,1.18,.36,2.36,.94,3.33,1.84,1.63,1.51,2.4,3.71,2.3,6.52-.36,9.92,.16,10.68,4.23,16.62,.34,.5,.7,1.03,1.1,1.61,2.4,3.53,.43,7.09-.96,8.9-.93,1.21-2.1,2.31-3.35,3.22h0c.02,.3,.04,.6,.06,.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M215.6,229.66c-1.56,.91-3.07,1.48-4.51,1.79-3.89,.82-7.26-.36-9.43-2.54-2.59-2.61-3.6-7.1-.51-10.62,2.98-3.41,1.7-5.22,.08-7.52-1.6-2.26-3.59-5.08-1.52-10.03,1.19-2.85,3.02-4.8,5.44-5.78,1.21-.49,2.44-.69,3.6-.72,.07,.25,.14,.51,.2,.76-1.13,.01-2.34,.19-3.52,.67-2.22,.9-3.91,2.71-5.02,5.36-1.91,4.56-.2,6.96,1.44,9.29,1.67,2.37,3.25,4.61-.13,8.46-2.49,2.84-2.3,6.78,.48,9.57,2.8,2.82,7.79,3.8,13.31,.45,.02,.18,.04,.36,.06,.55,0,.09,.02,.19,.03,.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M163.37,232.54c1.93,3.32,6.11,4.91,9.93,3.8,.58-.17,1.19-.39,1.8-.65,4.91-2.1,10.57-7.05,12.74-12.81,1.67-4.44,1.16-8.99-1.49-13.14-3.92-6.14-6.19-11.85-6.57-16.49-.23-2.75-2.12-4.88-4.81-5.43-2.71-.55-5.29,.67-6.58,3.11-.07,.13-.14,.26-.21,.39-3.3,6.44-1.33,11.1,.41,15.21,1.82,4.3,3.39,8.01-1.58,12.83-4.53,4.39-5.89,9.32-3.65,13.19Zm4.18-12.64c5.36-5.19,3.6-9.32,1.75-13.68-1.76-4.15-3.57-8.43-.43-14.56,.07-.13,.13-.26,.2-.38,.6-1.13,1.51-1.96,2.59-2.42,.96-.41,2.05-.53,3.16-.3,2.36,.49,4.01,2.35,4.21,4.75,.23,2.7,1.02,5.65,2.39,8.84,1.08,2.53,2.52,5.19,4.3,7.99,2.55,4,3.02,8.19,1.42,12.47-2.35,6.26-8.99,11.52-14.04,12.99-3.5,1.02-7.3-.43-9.06-3.45-2.06-3.54-.75-8.12,3.51-12.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M130.13,189.62c.11,.32,.21,.64,.32,.97,2.67,1.07,5.13,1.03,7.09,.61,1-.21,1.87-.52,2.58-.82,4.89-2.11,8.21-6.64,8.13-9.38-.03-1.03-.55-1.78-1.46-2.11-5.26-1.92-7.4-5.39-8.2-13.28-.22-2.14-1.07-3.8-2.54-4.95-.25,.13-.5,.26-.75,.4,.06,.05,.12,.09,.19,.14,1.35,1.01,2.13,2.52,2.33,4.49,.83,8.25,3.11,11.89,8.7,13.92,.62,.23,.93,.69,.95,1.41,.07,2.49-3.19,6.72-7.67,8.66-2.08,.9-5.67,1.79-9.69-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M157.28,190.89c.94,1.02,2.46,1.4,3.97,1.09,.5-.11,1-.29,1.47-.55,2.42-1.34,3.32-4.14,2.41-7.48-.95-3.48,.86-5.15,2.61-6.76,1.54-1.41,3.12-2.87,1.87-5.37-.96-1.92-2.74-2.82-5.12-2.6-2.81,.27-5.27,1.99-6.59,4.61-2.24,4.43-4.38,12.98-.62,17.07Zm1.3-16.72c1.06-2.11,3.01-3.62,5.2-4.08,.26-.05,.52-.09,.78-.12,2.08-.2,3.55,.54,4.37,2.18,1,1.99-.14,3.03-1.71,4.47-1.74,1.6-3.9,3.59-2.83,7.52,.81,2.98,.05,5.45-2.04,6.61-1.57,.87-3.51,.71-4.51-.38-3.5-3.8-1.41-11.96,.74-16.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M146.03,217.96c.43,2.02,1.24,3.66,2.64,4.48,2.1,1.23,4.16,1.71,5.68,1.39,.66-.14,1.21-.43,1.63-.87,1.24-1.33,.83-3.72-1.12-6.56-2.26-3.29-.28-5.38,1.83-7.6,1.79-1.89,3.65-3.84,2.61-6.51-.75-1.92-2.47-2.81-4.98-2.59-4.21,.38-7.68,3.76-8.25,8.05-.44,3.33-.66,7.19-.03,10.2Zm.79-10.1c.24-1.81,1.04-3.44,2.2-4.71,1.17-1.27,2.7-2.18,4.41-2.54,.31-.07,.62-.11,.95-.14,2.19-.19,3.57,.49,4.2,2.1,.87,2.22-.74,3.92-2.44,5.71-2.12,2.23-4.52,4.76-1.91,8.56,1.73,2.51,2.17,4.56,1.19,5.6-1.09,1.17-3.7,.9-6.36-.66-2.44-1.44-3.24-6.38-2.24-13.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M139.79,252.29c3.07-1.11,4.1,.43,5.59,2.66,1.34,1.99,3,4.47,6.73,5.35,1.27,.3,2.49,.29,3.64,.05,3.01-.63,5.47-2.88,6.65-5.4,1.59-3.39,.89-6.77-1.84-8.83-1.19-.89-1.81-1.74-1.93-2.59-.16-1.2,.74-2.36,1.7-3.59,1.33-1.71,2.84-3.64,1.68-6.12-.91-1.95-2.62-3.11-4.82-3.28-3.66-.27-7.76,2.21-10.45,6.3-2.3,3.5-5.21,5.03-7.42,5.69,.01,.25,.03,.52,.04,.78,2.37-.68,5.54-2.29,8.01-6.05,2.04-3.1,4.91-5.22,7.71-5.81,.69-.15,1.38-.2,2.05-.15,1.91,.14,3.39,1.15,4.18,2.84,.95,2.05-.29,3.64-1.6,5.32-1.01,1.3-2.06,2.64-1.86,4.16,.14,1.06,.87,2.07,2.22,3.1,2.89,2.18,2.73,5.51,1.61,7.9-1.5,3.2-5.22,5.92-9.42,4.93-3.44-.81-4.95-3.05-6.27-5.03-1.49-2.23-2.79-4.17-6.26-3.03,0,.26,.02,.53,.03,.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M178.67,243.02c.26,1.33,1.06,2.24,2.24,2.56,.63,.17,1.33,.17,2.07,.02,1.65-.35,3.46-1.47,4.94-3.15,1.52-1.72,3.04-1.5,5.14-1.2,2.04,.29,4.58,.66,7.82-.81,3.6-1.64,4.2-5.04,3.24-7.51-.88-2.23-3.25-4.17-6.39-3.13-2.25,.74-3.71,1.89-5.01,2.89-1.98,1.54-3.68,2.87-7.59,2.63-1.94-.12-3.5,.4-4.61,1.54-2.16,2.21-1.87,5.96-1.86,6.11,0,.02,0,.03,0,.04Zm.75-.13c-.02-.29-.2-3.61,1.65-5.5,.95-.97,2.3-1.41,4.01-1.31,4.19,.25,6.09-1.22,8.1-2.79,1.31-1.02,2.66-2.07,4.79-2.78,2.67-.88,4.69,.78,5.43,2.69,.84,2.14,.31,5.1-2.84,6.53-3.04,1.38-5.36,1.05-7.4,.76-1.18-.17-2.26-.32-3.3-.1-.87,.18-1.7,.63-2.52,1.55-1.93,2.18-4.5,3.38-6.24,2.91-.89-.24-1.47-.91-1.68-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M212.15,261.42c-2.62,4.34-1.52,9.17,1.08,11.34,1.25,1.04,2.73,1.45,4.3,1.21,.1-.08,.2-.16,.31-.24,.03-.19,.05-.39,.08-.6-1.54,.37-2.98,.06-4.2-.96-2.34-1.96-3.33-6.37-.91-10.35,2.45-4.04,.52-5.29-1.52-6.61-1.87-1.22-3.82-2.47-3.52-6.1,.15-1.79,.87-3.23,2.16-4.28,1.12-.91,2.55-1.44,3.95-1.74,1.04-.22,2.07-.31,2.95-.34-.02-.26-.04-.51-.06-.77-2.17,.08-5.2,.53-7.32,2.26-1.45,1.18-2.27,2.8-2.43,4.81-.33,4.08,2,5.59,3.87,6.8,2.01,1.31,3.35,2.17,1.28,5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M148.58,285.64c.25,.09,.5,.17,.76,.25,.03-1.18,.31-3.71,2.06-5.41,1.46-1.41,3.64-1.97,6.48-1.66,3.77,.42,5.48,1.98,6.98,3.36,2.53,2.32,4.29,3.42,10.89-.89,2.51-1.64,4.84-2.6,6.87-3.03,3.28-.69,5.8-.01,7.12,1.35,1.62,1.67,1.54,4.32-.2,7.18,.34-.08,.67-.16,1.01-.24,1.57-2.94,1.49-5.67-.26-7.48-2.35-2.42-8.03-2.96-14.96,1.57-6.43,4.21-7.76,2.99-9.96,.97-1.51-1.39-3.4-3.12-7.42-3.56-3.08-.34-5.47,.29-7.1,1.88-1.84,1.8-2.22,4.33-2.28,5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M191.51,273.34c.96,2.05,4.12,3.74,7.07,3.12,.13-.03,.26-.06,.38-.1,4.5-1.27,7.09-4.92,7.29-10.27,.15-4.14-.23-8.2-4.06-9.96-.02,0-.04-.02-.07-.02-.18-.04-4.42-1.07-7.06,.72-1.11,.75-1.77,1.89-1.96,3.37-.35,2.62,.45,4.23,1.02,5.4,.72,1.44,1.04,2.1-1.16,3.6-1.63,1.11-2.16,2.62-1.46,4.12Zm1.89-3.49c2.62-1.79,2.24-2.9,1.42-4.57-.56-1.14-1.27-2.57-.96-4.96,.17-1.26,.72-2.22,1.64-2.85,2.25-1.53,6.02-.71,6.41-.62,2.74,1.27,3.78,3.95,3.58,9.21-.13,3.53-1.41,8.06-6.73,9.57-2.65,.74-5.7-.79-6.55-2.61-.55-1.17-.13-2.27,1.19-3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M142.89,283.32c.23,.12,.47,.23,.71,.34,1.6-1.87,2.26-3.91,1.95-6.04-.5-3.46-3.39-6.36-5.3-7.92,0,.34,0,.68,0,1.02,1.78,1.57,4.12,4.11,4.54,7.01,.28,1.94-.34,3.79-1.84,5.52-.02,.02-.04,.05-.07,.08Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M128.16,116.92s-11.35-2.4-11.62-6.73c-.24-4,4.48-3.58,4.48-3.58,0,0-5.51-9.04-2.35-10.81,3.16-1.78,7.15,3.29,7.15,3.29,0,0-2.89-10.72,.97-9.95,3.86,.77,4.36,6.66,4.36,6.66,0,0,12.83-4.57,20.12-2.38,4.97,1.49,6.14,6.27,6.14,6.27,0,0,2.95-1.76,5.05-.68,2.09,1.08,.18,4.76,.18,4.76,0,0,3.24,2.49,2.25,6.45-.99,3.96-3.82,11.78-3.82,11.78l-32.91-5.09Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.18,148.42l1.1,5.22c.71,.36,1.42,.66,2.12,.9,10.2,3.53,18.55-5.26,18.55-5.26l-3.81-18.08-15.82,15.17-2.14,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M144.18,148.42l1.1,5.22c.71,.36,1.42,.66,2.12,.9,7.07-4.68,10.98-13.95,10.98-13.95l-12.05,5.78-2.14,2.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M134.14,106.19s-12.35,3.84-5.02,16.07c0,0,6.04-12.68,5.02-16.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M132.79,126.68s-3.7-2.88-4.64,.98c-.94,3.85,1.84,10.66,6.11,8.56l-1.47-9.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.22,139.62s2.26,10.79,13.47,8.4c11.14-2.37,16.89-12.72,17.2-13.21,0,0,0-.01,0-.01l-.36-2.29-1.84-11.9-.99-6.36s-.96-11.62-12.15-11.42c-8.18,.15-15.27,3.01-18.13,7.89-1.05,1.8-1.53,3.88-1.27,6.2l2.03,11.37,.5,2.79,1.53,8.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M155.09,122.01s-1.65,6.62-5.3,6.32c-3.65-.31-7.7,.11-10.52,2.22,0,0-5.65-.84-8.32,1.97-1.79,1.89,2.42,15.95,10.23,16.45s17.2-4.18,18.13-11.64c.93-7.46-.47-13.35-.47-13.35l-3.75-1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M136.97,133.7s6.31-.65,9.4-2.42c0,0,1.38,6.16-3.95,6.69-4.28,.43-5.45-4.28-5.45-4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M145.11,126.59c.17,.78,1.92,1.08,3.91,.66,1.99-.42,3.48-1.4,3.31-2.18-.17-.79-1.92-1.08-3.91-.66-1.99,.42-3.48,1.4-3.31,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M130.69,131.07c.28-.03,.58-.08,.88-.14,1.99-.42,3.48-1.4,3.31-2.18-.17-.78-1.92-1.08-3.91-.66-.27,.06-.53,.12-.78,.2l.5,2.79Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M144.32,122.24c.23,1.08,.9,1.85,1.5,1.72,.6-.13,.91-1.1,.68-2.18-.23-1.08-.9-1.85-1.5-1.72-.6,.13-.91,1.1-.68,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M133.65,124.49c.23,1.08,.9,1.85,1.5,1.72,.6-.13,.91-1.1,.68-2.18-.23-1.08-.9-1.85-1.5-1.72-.6,.13-.91,1.1-.68,2.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M140.28,128.76c.25-.05,.4-.29,.35-.54s-.29-.4-.54-.35c-1.63,.34-2.57-.35-2.91-.68,1-4.02,1.98-8.07,1.99-8.11,.06-.24-.09-.49-.33-.55-.24-.06-.49,.09-.55,.33-.01,.04-1.03,4.24-2.05,8.34-.03,.13,0,.27,.08,.38,.05,.07,1.33,1.72,3.96,1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M148.68,116.16c-.49-1.09-1.89-3.02-5.56-2.42-.45,.07-.79,.45-.81,.9h0c-.03,.57,.42,1.05,.99,1.04,1-.03,2.51,.2,3.65,1.61,.35,.44,1.02,.46,1.42,.07l.09-.09c.3-.29,.38-.73,.21-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M130.02,120.09c0-1.19,.5-3.53,4.11-4.46,.44-.11,.9,.1,1.11,.5h0c.26,.51,.04,1.13-.49,1.35-.93,.38-2.22,1.2-2.69,2.94-.15,.54-.74,.83-1.27,.64l-.12-.04c-.39-.14-.65-.52-.64-.93Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M158.46,131.17c.08,.11,2.19,3.1,4.43,3.64,0,0,0-.01,0-.01l-.36-2.29s-1.83,.07-4.09-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.85,123.27s3.09-6.7,7.21-2.81c3.39,3.2,.53,14.01-5.33,11.75l-1.88-8.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M160.96,130.33c.22-.05,.38-.26,.36-.49-.44-4.48,2.91-6.79,3.05-6.88,.21-.14,.26-.42,.12-.63-.14-.21-.42-.26-.63-.13-.16,.11-3.95,2.69-3.45,7.72,.02,.25,.25,.43,.5,.41,.02,0,.03,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M164.53,126.77c.13-.03,.24-.11,.31-.24,.11-.22,.03-.5-.2-.61-.21-.11-2.06-1.03-3.32-.4-.22,.11-.32,.38-.21,.61,.11,.22,.38,.32,.61,.21,.72-.36,2.09,.18,2.51,.4,.1,.05,.2,.06,.3,.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M129.43,110.72c.16,.36,.39,.65,.69,.86,2.66,1.83,7.64-.07,12.1-2.55,4.46-2.48,8.54,.28,8.54,.28-.36,4.85,4.21,4.27,3.98,7.94-.23,3.67,1.1,8.16,1.1,8.16l2.72-.96c.26-1.75,1.35-3.09,2.12-3.84l-.99-6.36s-.96-11.62-12.15-11.42c-8.18,.15-15.27,3.01-18.13,7.89Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M212.98,263.67s10.68,42.13-44.69,42.13c-29.57,0-43.63-2.85-43.63-2.85,0,0-.71,26.11-2.09,37.13-1.38,11.02-6.25,38.46-6.25,38.46l-23.29,1.8s-3.72-95.6,10.55-104.4c14.27-8.8,34.8-9.06,70.04-12.45,0,0,31.64-5.36,39.35,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M113.13,370.9s-.1,0-.15-.02c-.34-.08-.55-.42-.47-.76,3.22-13.45,4.5-32.71,5.52-48.19,1.01-15.26,1.62-23.29,3.2-24.69,1.75-1.54,6.93-.99,15.52-.08,10.65,1.13,26.73,2.84,44.08,.85,8.62-.99,15.22-4.36,19.63-10.03,7.91-10.17,6.1-24.44,6.08-24.58-.05-.35,.2-.67,.54-.71,.35-.05,.67,.2,.71,.54,.08,.6,1.91,14.93-6.33,25.52-4.63,5.95-11.52,9.49-20.49,10.52-17.49,2-33.66,.29-44.36-.85-7.39-.79-13.22-1.41-14.55-.23-.3,.27-.9,1.58-1.51,7.37-.46,4.28-.83,9.92-1.26,16.46-1.03,15.53-2.31,34.85-5.56,48.4-.07,.29-.33,.49-.62,.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M93.28,372.8c-.33,0-.61-.26-.63-.6-.02-.35,.24-.65,.59-.67l23.82-1.44c.35-.02,.65,.25,.67,.59,.02,.35-.25,.65-.59,.67l-23.82,1.44s-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M87.59,266.56h69.77c.16,0,.29,.13,.29,.29v8.59c0,.16-.13,.29-.29,.29H87.59c-.16,0-.29-.13-.29-.29v-8.59c0-.16,.13-.29,.29-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79.96,275.72c-2.65,0-4.96-1.78-5.65-4.34l-13.16-49.27c-.8-3.01,1.47-5.97,4.58-5.97h31.5c2.12,0,3.99,1.41,4.57,3.46l15.76,56.11h-37.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M101.8,219.62l15.63,55.65h3.6l-15.63-55.65c-.58-2.05-2.44-3.46-4.57-3.46h-3.6c2.13,0,3.99,1.42,4.57,3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M92.9,246.74c.72,3.09-1.21,5.6-4.31,5.6s-6.18-2.51-6.9-5.6c-.72-3.09,1.21-5.6,4.31-5.6s6.18,2.51,6.9,5.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.86,255.65s-14.28,.98-18.84,5.35l2.78,9.88s8.54-3.49,10.9-3.15c2.37,.34,3.78,4.22,11.69,1.86l-6.52-13.93Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M135.94,255l1.61-.66,1.67-.7c1.12-.47,2.23-.96,3.35-1.46,2.23-.99,4.44-2.01,6.64-3.07,4.39-2.11,8.7-4.35,12.85-6.72,4.15-2.38,8.17-4.9,11.83-7.6,.91-.68,1.81-1.36,2.67-2.05,.86-.7,1.69-1.4,2.49-2.11,1.57-1.42,3.01-2.88,4.14-4.3,.56-.7,1.06-1.41,1.43-2.03,.33-.57,.65-1.2,.93-1.91,.56-1.41,1-3.08,1.3-4.91,.59-3.68,.61-7.93,.23-12.28-.38-4.36-1.15-8.86-2.16-13.33-.51-2.24-1.09-4.48-1.72-6.69-.32-1.11-.65-2.21-.99-3.29-.17-.54-.35-1.08-.52-1.61l-.26-.77-.13-.37-.06-.17-.03-.08v-.03c-3.02-6.28-.37-13.82,5.91-16.83,6.28-3.01,13.82-.36,16.83,5.92,.29,.61,.53,1.23,.72,1.85l.38,1.31,.1,.35,.08,.28,.15,.54,.27,1.04c.17,.69,.34,1.36,.5,2.04,.32,1.35,.62,2.69,.89,4.03,.56,2.69,1.04,5.38,1.45,8.1,.81,5.44,1.36,10.97,1.43,16.69,.04,2.86-.06,5.77-.32,8.73-.27,2.97-.73,6-1.48,9.1-.76,3.1-1.83,6.27-3.41,9.43-.8,1.58-1.73,3.14-2.82,4.65-1.06,1.46-2.14,2.72-3.25,3.91-2.22,2.36-4.51,4.32-6.82,6.11-2.31,1.77-4.65,3.36-7,4.84-4.7,2.94-9.45,5.44-14.24,7.73-4.79,2.28-9.62,4.34-14.48,6.25-2.43,.95-4.87,1.87-7.33,2.75-1.23,.44-2.46,.87-3.7,1.29l-1.87,.63-1.95,.63c-4.23,1.36-8.77-.96-10.14-5.19-1.3-4.03,.74-8.33,4.6-9.92l.26-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M194.36,227.88s-.1,0-.14-.02c-4.87-1.46-10.31-1.24-10.36-1.23-.28,.01-.51-.2-.52-.48s.2-.51,.48-.52c.23-.01,5.66-.24,10.7,1.27,.26,.08,.41,.36,.34,.62-.06,.22-.26,.36-.48,.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M185.09,226.62c-.14,0-.28-.06-.38-.17-.18-.21-.16-.52,.05-.71,1.82-1.57,4.1-2.26,4.2-2.29,.26-.08,.54,.07,.62,.34,.08,.26-.07,.54-.34,.62-.02,0-2.18,.66-3.83,2.08-.09,.08-.21,.12-.33,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M212.16,196.04l-10.35,2.84-.76,.21-7.15,1.96-.87,.24-9.2,2.52-.71-3.26-.16-.78-1.66-7.66-.17-.77-3.13-14.45c-.85-3.34-1.41-7.52-.94-10.93,.69-5.05,5.12-11.6,13.29-12.04,1.46-.08,2.83,.14,4.11,.61,.26,.08,.52,.19,.77,.3,2.47,1.12,4.61,3.18,6.45,5.83,.15,.21,.29,.42,.42,.64,3.5,5.32,5.89,12.76,7.49,19.72,.07,.27,.13,.54,.19,.81,.74,3.31,1.3,6.5,1.72,9.26,.07,.43,.13,.85,.18,1.26,.2,1.37,.36,2.61,.48,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M211.5,191.09c-1.23-1.12-2.89-1.9-5.45-1.44-3.04,.54-5.43-.44-6.39-2.63-.73-1.64-.39-3.56,.78-4.46,2.34-1.8,5.93-1.65,9.34-.73-.06-.27-.12-.54-.19-.81-3.5-.89-7.16-.95-9.62,.93-1.1,.85-1.61,2.33-1.43,3.86,.06,.51,.2,1.02,.41,1.52,1.12,2.53,3.83,3.68,7.24,3.07,2.75-.5,4.27,.57,5.49,1.95-.05-.41-.11-.83-.18-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M200.69,168.46c-2.12-3.07-.53-5.1,1.41-7.16-.13-.22-.27-.43-.42-.64-2.05,2.15-4.12,4.62-1.62,8.24,1.73,2.51,2.16,4.55,1.19,5.6-1.09,1.17-3.71,.9-6.36-.66-2.44-1.44-3.23-6.38-2.24-13.92,.24-1.81,1.04-3.44,2.2-4.71,.12-.13,.25-.26,.38-.38-.25-.11-.51-.22-.77-.3-1.37,1.41-2.29,3.24-2.57,5.28-.43,3.33-.66,7.2-.03,10.2,.43,2.02,1.24,3.66,2.64,4.49,2.1,1.23,4.17,1.71,5.68,1.39,.66-.14,1.22-.43,1.63-.87,1.24-1.33,.83-3.72-1.12-6.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M181.32,191.44c-1.7-10.11-3.85-19.57-3.87-19.67-.05-.2-.25-.33-.45-.28-.2,.05-.33,.25-.28,.45,.02,.1,2.16,9.51,3.85,19.57,.11,.4,.75,.42,.75-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M178.58,179.24c-.07,0-.14-.02-.2-.06l-3.9-2.5c-.17-.11-.23-.34-.11-.52,.11-.18,.34-.23,.52-.11l3.9,2.5c.17,.11,.23,.34,.11,.52-.07,.11-.19,.17-.32,.17Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.31,180.32c-1.32,0-2.53-.48-3.61-1.43-6.17-5.43-6.14-25.17-6.14-26.01,0-.39,.32-.71,.72-.71h0c.4,0,.72,.32,.71,.72,0,.2-.03,19.92,5.65,24.92,.97,.85,2.03,1.19,3.22,1.03,7.59-1,11.04-23.09,11.73-31.52,.03-.39,.38-.69,.77-.66,.39,.03,.69,.38,.66,.77,0,.08-.66,7.86-2.51,15.71-2.55,10.78-6.07,16.54-10.46,17.12-.25,.03-.5,.05-.75,.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M210.63,364.7h-74.78c-1.75,0-3.17-1.42-3.17-3.17s1.42-3.17,3.17-3.17h74.78c1.75,0,3.17,1.42,3.17,3.17s-1.42,3.17-3.17,3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M128.97,413.07c-.14,0-.28,0-.42-.03-1.73-.23-2.95-1.83-2.72-3.56l13.62-101.7c.21-1.57,1.55-2.75,3.14-2.75h61.01c1.59,0,2.93,1.18,3.14,2.75l13.41,101.7c.23,1.73-.99,3.33-2.73,3.55-1.73,.23-3.33-.99-3.55-2.73l-13.05-98.95h-55.46l-13.25,98.96c-.21,1.59-1.57,2.75-3.14,2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M160.26,308.2h39.62c12.55,0,26-6.87,27.92-19.27,2.58-16.59,3.21-32.65,2.49-47.39-.81-16.67-7.29-32.15-20.4-42.48h0s5.66,64.3,.55,82.06c-6.82,23.74-50.2,27.08-50.2,27.08Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M39.65,176.05v19.02c0,2.51,2.04,4.55,4.55,4.55h34.54l10.43,3.74c1.07,.38,2.1-.67,1.68-1.73l-3.94-10.19v-15.4c0-2.51-2.04-4.55-4.56-4.55H44.21c-2.51,0-4.55,2.04-4.55,4.55Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M69.66,186.1c0,1.82,1.47,3.29,3.29,3.29s3.29-1.48,3.29-3.29-1.47-3.29-3.29-3.29-3.29,1.47-3.29,3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M59.23,186.1c0,1.82,1.48,3.29,3.29,3.29s3.29-1.48,3.29-3.29-1.47-3.29-3.29-3.29-3.29,1.47-3.29,3.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M48.8,186.1c0,1.82,1.48,3.29,3.29,3.29s3.29-1.48,3.29-3.29-1.48-3.29-3.29-3.29-3.29,1.47-3.29,3.29Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 620.89,
    cy: 101.29,
    rx: 26.93,
    ry: 26.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 620.89,
    cy: 97.83,
    rx: 26.93,
    ry: 26.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 620.89,
    cy: 97.83,
    rx: 21.9,
    ry: 21.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M642.79,97.83c0,.58-.02,1.15-.07,1.71-.89-11.13-10.34-19.92-21.83-19.92s-20.94,8.79-21.83,19.92c-.04-.56-.07-1.13-.07-1.71,0-11.92,9.82-21.62,21.9-21.62s21.9,9.7,21.9,21.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M620.89,100.08c-.17,0-.33-.08-.44-.22l-10.74-14.28c-.18-.24-.13-.58,.11-.76,.24-.18,.59-.13,.77,.11l10.48,13.94,11.91-5.16c.28-.12,.6,0,.72,.28,.12,.27,0,.59-.28,.71l-12.31,5.34c-.07,.03-.15,.05-.22,.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 64.4,
    y: 92.19,
    width: 9.67,
    height: 41.24,
    rx: 1.19,
    ry: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 65.87,
    y: 111.4,
    width: 6.73,
    height: 2.82,
    rx: 1.17,
    ry: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 64.4,
    y: 95.52,
    width: 9.67,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 64.4,
    y: 98.85,
    width: 9.67,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 64.4,
    y: 123.43,
    width: 9.67,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 64.4,
    y: 126.76,
    width: 9.67,
    height: 1.59
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 45.06,
    y: 92.19,
    width: 9.67,
    height: 41.24,
    rx: 0.3,
    ry: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 46.53,
    y: 111.4,
    width: 6.73,
    height: 2.82,
    rx: 1.17,
    ry: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 45.06,
    y: 95.52,
    width: 9.67,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 45.06,
    y: 98.85,
    width: 9.67,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 45.06,
    y: 123.43,
    width: 9.67,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 45.06,
    y: 126.76,
    width: 9.67,
    height: 1.59
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 54.73,
    y: 92.19,
    width: 9.67,
    height: 41.24,
    rx: 1.19,
    ry: 1.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 56.2,
    y: 111.4,
    width: 6.73,
    height: 2.82,
    rx: 1.17,
    ry: 1.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 54.73,
    y: 95.52,
    width: 9.67,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 54.73,
    y: 98.85,
    width: 9.67,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 54.73,
    y: 123.43,
    width: 9.67,
    height: 1.59
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 54.73,
    y: 126.76,
    width: 9.67,
    height: 1.59
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 77.17,
    y: 91.72,
    width: 9.67,
    height: 41.24,
    rx: 0.3,
    ry: 0.3,
    transform: "translate(-16.84 14.49) rotate(-9.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 78.64,
    y: 110.93,
    width: 6.73,
    height: 2.82,
    rx: 0.26,
    ry: 0.26,
    transform: "translate(-16.84 14.49) rotate(-9.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 74.55,
    y: 95.26,
    width: 9.67,
    height: 1.59,
    transform: "translate(-14.28 13.86) rotate(-9.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 75.08,
    y: 98.55,
    width: 9.67,
    height: 1.59,
    transform: "translate(-14.79 13.99) rotate(-9.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 78.99,
    y: 122.81,
    width: 9.67,
    height: 1.59,
    transform: "translate(-18.61 14.92) rotate(-9.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 79.52,
    y: 126.1,
    width: 9.67,
    height: 1.59,
    transform: "translate(-19.12 15.04) rotate(-9.16)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "114.64 144.48 27.06 144.48 25.15 139.39 116.83 139.39 114.64 144.48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 25.15,
    y: 133.34,
    width: 91.68,
    height: 6.05
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "34.49 139.39 36.94 144.53 42.72 144.53 44.36 139.39 34.49 139.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "107.48 139.39 105.03 144.53 99.26 144.53 97.61 139.39 107.48 139.39"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 545.84,
    cy: 410.66,
    rx: 132.05,
    ry: 7.77
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M597.6,414.3c-41.25-1.45-83.92-7.08-106.01-83.1-6.57-22.6-2.3-39.71,4.91-52.61,1.78-3.19,3.74-6.11,5.76-8.8h0c.76-1.02,1.53-2,2.3-2.94,16.12-19.77,43.15-26.86,67.12-18.12,13.44,4.9,30.68,12.14,46.05,21.56,30.88,18.93,38.13,40.5,48.22,77.52,.87,3.18,1.73,6.74,2.39,10.53,.35,2.02,.64,4.11,.84,6.23,2.24,23.67-6.89,52-71.58,49.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M669.19,364.57c-1.37,3.85-3.32,7.77-5.92,11.49-7.8,11.18-24.05,24.68-57.13,25.56-1.46,.04-2.89,.06-4.31,.06-12.64,0-23.79-1.53-33.98-4.64-10.66-3.25-19.96-8.17-28.44-15.01-14.17-11.44-25.86-28.17-37.87-54.24-4.75-10.3-7.21-20.74-7.31-31.03-.06-6.13,.7-12.22,2.29-18.16,1.78-3.19,3.74-6.11,5.76-8.8-.51,1.18-1.01,2.42-1.48,3.71-4.32,11.85-7.3,30.71,3.07,53.21,21.09,45.77,45.54,73.83,102.21,72.35,32.02-.84,47.64-13.77,55.1-24.46,3.9-5.58,6.1-11.23,7.18-16.26,.35,2.02,.64,4.11,.84,6.23Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M610.17,224.28s25.9,35.14,31.81,52.65-8.43,29.94-8.43,29.94l-13.32,5s-13.69-61.81-10.06-87.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M607.89,322.72c-11.32,3.75-38.98,13.59-50.99,9.61-.51-.17-.98-.36-1.43-.58-1.31-.64-2.36-1.5-3.1-2.62-4.71-7.17-9.38-37.26-7.28-54.94,.26-2.21,.39-4.61,.43-7.13,.06-3.71-.06-7.68-.22-11.67-.59-15.02-2.96-25.39,3.47-29.04,5.77-3.28,13.07-5.84,17.72-6.95,2.88-.69,7.6-2.13,10.91-2.07l14.32,2.6s12.36,2.06,15.21,4.17c2.85,2.1,4.31,11.37,9.46,19.86,5.15,8.49,6.27,17.01,1.35,26.33-4.28,8.11-3.53,5.03-4.09,18.33-.69,16.3,16.34,26.77-5.76,34.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M569.86,246.35s15.52-4.01,35.33-.31l.48,13.69s-21.78-2.42-35.5,1.07l-.31-14.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M587.7,234.79c-.21,0-.42,0-.64-.02-8.48-.44-16.26-7.92-16.58-8.24-.23-.22-.23-.59-.01-.82,.22-.23,.59-.23,.82-.01,.08,.07,7.79,7.5,15.83,7.91,7.7,.41,8.63-7.23,8.67-7.56,.04-.32,.32-.55,.64-.51,.32,.03,.55,.32,.51,.64,0,.09-1.02,8.61-9.24,8.61Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M563.66,303.32c-.06-.05-.11-.1-.16-.17-.17-.29-.08-.66,.2-.83,11.03-6.68,21.61-9.03,28.54-9.83,7.53-.87,12.38-.17,12.58-.14,.33,.05,.56,.36,.51,.69-.05,.33-.36,.56-.69,.51-.05,0-4.93-.71-12.31,.15-6.8,.79-17.19,3.11-28.01,9.66-.22,.13-.48,.11-.67-.03Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M578.07,328.17c-10.19-3.23-19.41-9.73-25.7-15.52-.5-.46-.98-.91-1.44-1.36-3.26-3.17-5.56-1.54-6.56-3.36-3.81-6.97-1.65-34.32,0-44.37,1.65-10.04-5.28-28.44-1.55-35.02,3.73-6.58,16.58-8.88,16.58-8.88,0,0-1.82-2.12,1.63-4.55,3.45-2.43,12.63-1.42,12.63-1.42,.44,43.47,6.6,83.85,4.41,114.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M568.06,315.71c-.28,0-.52-.2-.56-.48-4.64-30.15-.05-86.87,0-87.44,.03-.31,.3-.54,.61-.52,.31,.03,.55,.3,.52,.61-.05,.57-4.62,57.15,0,87.17,.05,.31-.17,.6-.48,.65-.03,0-.06,0-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M577.38,320.23c-.27,0-.51-.19-.56-.47-6.07-34.63-6.55-94.39-6.55-94.99,0-.31,.25-.57,.56-.57h0c.31,0,.57,.25,.57,.56,0,.6,.49,60.26,6.54,94.8,.05,.31-.15,.6-.46,.66-.03,0-.07,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M567.32,224.42s-.1,0-.15-.02c-4.8-1.28-7.74-4.11-7.87-4.23-.22-.22-.23-.58,0-.8,.22-.22,.58-.23,.8,0h0s2.86,2.75,7.36,3.95c.3,.08,.48,.39,.4,.7-.07,.25-.3,.42-.55,.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M622.22,309.19s-3.63,12.23-17.15,18.06c-1.68-33.16-5.48-71.03-10.39-111.31,0,0,5.17-.91,7.32,2.05,.93,1.27,1.13,3.43,1.13,3.43,0,0,2.64,.51,5.53,1.86,2.89,1.35,2.56,3.2,3.25,7.9,.69,4.7,7.95,11.97,10.31,21.82,2.36,9.85-3.9,16.13-5.85,24.4-1.95,8.26,5.85,31.81,5.85,31.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M610.62,314.32c-.31,0-.56-.24-.57-.55-1.31-45.11-9.55-85.42-9.63-85.82-.06-.31,.13-.61,.44-.67,.31-.06,.61,.13,.67,.44,.08,.4,8.34,40.8,9.65,86.02,0,.31-.24,.58-.55,.58,0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M598.17,225.67c-.27,0-.51-.2-.56-.47-.05-.31,.16-.6,.46-.66,.04,0,3.68-.67,4.51-3.3,.09-.3,.41-.47,.71-.37,.3,.09,.46,.41,.37,.71-1.05,3.3-5.23,4.05-5.4,4.08-.03,0-.06,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M609.29,314.32c-.28,0-.53-.21-.56-.5-4-33.26-10.32-86.41-10.38-86.94-.04-.31,.19-.59,.5-.63,.31-.04,.59,.19,.63,.5,.06,.53,6.38,53.69,10.38,86.94,.04,.31-.18,.59-.5,.63-.02,0-.05,0-.07,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M575.7,338.2c1.73,1.24,4.45,2.53,8.54,3.83,23.2,7.38,44.47-4.53,44.47-4.53,1.29-6.35,.49-13.57-1.65-16.21,.67-.94,.23-2.06,.23-2.06l21.35-22.16c-12.14,10.06-27.16,13.35-38.85,20.42h0c-3.37,2.04-6.4,3.83-8.62,5.07-3.39,1.9-7.71,2.09-11.95,1.5-8.26-1.14-16.18-5.21-16.18-5.21,0,0-26.59-12.05-31.57-11.65-3.88,.31,16.98,22.09,34.23,31.01Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M616.79,356.77s-6.84-1.97-8.95-4.19l-4.76,11.2,16.19,5.05s.23-9.84-2.49-12.06Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M655.86,389.13l-20.93-46.45c-.78-.06-1.76,.15-2.86,.55-4.06,1.48-9.77,5.56-13.44,7.95-.43,.28-.83,.54-1.2,.77-.62,.38-1.15,.68-1.55,.87-3.23,1.45-1.53,3.19-1.53,3.19,6.02,3.01,2.35,11.93,6.02,14.01,0,0,1.56,.91,6.54,3.1,4.98,2.19,9.99,7.48,14.63,11.81,5.99,5.6,9.75,6.25,11.9,5.74,1.71-.41,2.41-1.54,2.41-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M655.86,389.13l-20.93-46.45c-.78-.06-1.76,.15-2.86,.55l21.37,47.44c1.71-.41,2.41-1.54,2.41-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M637.07,347.42l-.62-1.38c-.95,2.09-2.79,4.46-6.31,5.85-4.69,1.84-9.03,.48-11.5-.7-.43,.28-.83,.54-1.2,.77,2.51,1.35,7.52,3.27,13.14,1.07,3.37-1.32,5.34-3.51,6.49-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M629.31,371.1c-.15-.34-.53-.55-.92-.48-.46,.08-.76,.52-.68,.98l.59,3.23c.08,.46,.52,.76,.98,.68,.46-.08,.76-.52,.68-.98l-.59-3.23c-.01-.07-.03-.13-.06-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M625.59,369.3c-.15-.34-.53-.55-.92-.48-.46,.08-.76,.52-.68,.98l.59,3.23c.08,.46,.52,.76,.98,.68,.46-.08,.76-.52,.68-.98l-.59-3.23c-.01-.07-.03-.13-.06-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M632.3,373.24c-.15-.34-.53-.55-.92-.48-.46,.08-.76,.52-.68,.98l.59,3.23c.08,.46,.52,.76,.98,.68,.46-.08,.76-.52,.68-.98l-.59-3.23c-.01-.07-.03-.13-.06-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M635.23,375.41c-.15-.34-.53-.55-.92-.48-.46,.08-.76,.52-.68,.98l.59,3.23c.08,.46,.52,.76,.98,.68,.46-.08,.76-.52,.68-.98l-.59-3.23c-.01-.07-.03-.13-.06-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M638.15,377.9c-.15-.34-.53-.55-.92-.48-.46,.08-.76,.52-.68,.98l.59,3.23c.08,.46,.52,.76,.98,.68,.46-.08,.76-.52,.68-.98l-.59-3.23c-.01-.07-.03-.13-.06-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M640.98,380.76c-.15-.34-.53-.55-.92-.48-.46,.08-.76,.52-.68,.98l.59,3.23c.08,.46,.52,.76,.98,.68,.46-.08,.76-.52,.68-.98l-.59-3.23c-.01-.07-.03-.13-.06-.2Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M541.47,307.19s-16.83-9.08-26.57-2.06c-17.82,12.84,12.42,37.53,47.02,49.59,34.6,12.06,45.83,10.41,45.83,10.41,0,0,7.52-2.07,4.85-14.25,0,0-19.94-7.58-30.32-15.52-10.38-7.94-17.45-17.67-40.8-28.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M611.24,354.43c-7.26-1.74-22.04-8.53-39.55-18.14-13.1-7.19-28.2-16.38-30.42-19.57-1.2-1.72-1.5-3.13-.9-4.19,.9-1.58,3.5-1.74,4.68-1.73,.3,0,.54,.26,.52,.56h0c-.02,.28-.25,.49-.53,.49-1.16,0-3.19,.19-3.76,1.2-.48,.84,.2,2.13,.85,3.06,1.79,2.57,14.43,10.67,30.06,19.25,13.46,7.39,30.85,16.01,39.29,18.04l-.25,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M609.88,349.27c-.82,6.4-2.48,12.22-6.09,16.69,0,0,3.1,2.23,5.93,.63,2.16-1.22,6.33-11.22,4.74-16.56-1.81-.99-3.37-1.33-4.57-.75Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M565.97,355.51s6.88-1.33,8.83-3.69l5.49,10.85-15.81,6.12s-1.06-10.89,1.5-13.29Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M529.33,391.49l17.78-47.74c.78-.12,1.76,.03,2.89,.36,4.15,1.21,10.12,4.89,13.94,7.04,.45,.25,.86,.48,1.25,.68,.65,.34,1.19,.61,1.61,.76,3.32,1.23,1.94,2.17,1.94,2.17-6.54,3.07-1.75,12.97-5.27,15.3,0,0-1.5,1.01-6.32,3.53-4.82,2.52-9.47,8.13-13.81,12.76-5.6,5.98-9.31,6.89-11.49,6.52-1.73-.29-2.51-1.38-2.51-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M529.33,391.49l17.78-47.74c.78-.12,1.76,.03,2.89,.36l-18.16,48.76c-1.73-.29-2.51-1.38-2.51-1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M545.3,348.62l.53-1.42c1.09,2.02,3.08,4.27,6.69,5.41,4.8,1.53,9.04-.12,11.43-1.47,.45,.25,.86,.48,1.25,.68-2.41,1.52-7.29,3.77-13.04,1.94-3.45-1.1-5.56-3.15-6.85-5.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M554.63,371.73c.13-.35,.49-.59,.88-.54,.46,.05,.79,.47,.74,.93l-.37,3.26c-.05,.46-.47,.79-.93,.74-.46-.05-.79-.47-.74-.93l.37-3.26c0-.07,.02-.14,.05-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M558.21,369.69c.13-.35,.49-.59,.88-.54,.46,.05,.79,.47,.74,.93l-.37,3.26c-.05,.46-.47,.79-.93,.74-.46-.05-.79-.47-.74-.93l.37-3.26c0-.07,.02-.14,.05-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M551.78,374.06c.13-.35,.49-.58,.88-.54,.46,.05,.79,.47,.74,.93l-.37,3.26c-.05,.46-.47,.79-.93,.74-.46-.05-.79-.47-.74-.93l.37-3.26c0-.07,.02-.14,.05-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M549.01,376.43c.13-.35,.49-.58,.88-.54,.46,.05,.79,.47,.74,.93l-.37,3.26c-.05,.46-.47,.79-.93,.74-.46-.05-.79-.47-.74-.93l.37-3.26c0-.07,.02-.14,.05-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M546.25,379.1c.13-.35,.49-.58,.88-.54,.46,.05,.79,.47,.74,.93l-.37,3.26c-.05,.46-.47,.79-.93,.74-.46-.05-.79-.47-.74-.93l.37-3.26c0-.07,.02-.14,.05-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M543.63,382.14c.13-.35,.49-.59,.88-.54,.46,.05,.79,.47,.74,.93l-.37,3.26c-.05,.46-.47,.79-.93,.74-.46-.05-.79-.47-.74-.93l.37-3.26c0-.07,.02-.14,.05-.2Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M641.79,299.82s15.92-10.59,26.27-4.49c18.93,11.15-8.92,38.51-42.27,53.69-33.34,15.18-44.68,14.57-44.68,14.57,0,0-7.67-1.37-6.14-13.75,0,0,19.16-9.38,28.77-18.24,9.6-8.86,15.75-19.2,38.05-31.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M612.67,354.73c-1.84,.6-3.7,1.21-5.63,1.82-7.46,2.35-15.98,4.81-23.69,6.7l-.03,1.1c6.96-1.7,15.14-4,24.03-6.8,1.74-.55,3.51-1.12,5.29-1.71l.03-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M576.64,353.25c7.07-2.4,21.17-10.51,37.72-21.69,12.38-8.36,26.58-18.9,28.49-22.28,1.03-1.82,1.21-3.25,.51-4.25-1.04-1.49-3.64-1.42-4.82-1.3-.3,.03-.52,.31-.47,.61h0c.05,.27,.29,.46,.57,.44,1.16-.11,3.19-.1,3.86,.85,.55,.79,0,2.14-.56,3.13-1.54,2.72-13.39,11.94-28.17,21.93-12.72,8.59-29.25,18.77-37.47,21.57l.34,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M577.53,347.99c1.4,6.3,3.59,11.94,7.6,16.06,0,0-2.88,2.51-5.84,1.17-2.26-1.02-7.33-10.6-6.24-16.06,1.71-1.15,3.23-1.63,4.48-1.17Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M575.38,297.47l-1.28,18.27s-21.73-3.1-32.39-5.82c-3.1-.79-6.59-1.81-9.79-3.51-5.89-3.13-10.77-8.58-10.41-19.2,.11-3.41,.77-7.35,2.11-11.93,7.76-26.53,20.76-48.81,20.76-48.81,16.73,7.16,15.32,19.08,15.32,19.08-4.77,12.73-15.32,39.84-15.32,39.84,6.12,7.48,31,12.07,31,12.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M544.38,285.97c-.1,0-.21-.03-.3-.09-1.85-1.14-6.88-2.33-6.93-2.34-.31-.07-.5-.38-.42-.68,.07-.31,.38-.49,.68-.42,.18,.04,3.71,.87,6.04,1.87-.34-.76-.9-1.57-1.67-2.45-.21-.24-.18-.59,.05-.8,.24-.21,.59-.18,.8,.05,1.34,1.52,2.1,2.9,2.31,4.21,.04,.22-.06,.44-.24,.56-.1,.06-.21,.1-.32,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M531.92,306.42c-5.89-3.13-10.77-8.58-10.41-19.2,4.66,2.44,12.79,8.35,10.41,19.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M561.71,294.67s-.09,0-.14-.02c-10.76-2.78-17.3-8.58-17.57-8.83-.19-.17-.24-.45-.13-.68,7.67-15.09,12.53-27.07,15.28-37.71,.08-.3,.39-.49,.69-.41,.3,.08,.49,.39,.41,.69-2.75,10.63-7.57,22.56-15.17,37.54,1.45,1.2,7.61,5.93,16.77,8.29,.3,.08,.49,.39,.41,.69-.07,.26-.3,.43-.55,.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M557.4,255.9c-.12,0-.25-.04-.35-.12-.25-.2-.29-.55-.09-.8l3.99-5.01c.2-.25,.55-.29,.8-.09,.25,.2,.29,.55,.09,.8l-3.99,5.01c-.11,.14-.28,.21-.44,.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M576,209.84l19.3,2.76c12.54-1.25,16.53-6.24,18.58-16.78,1.03-5.3,.35-9.98-.66-13.46-.26-3.96-1.17-7.38-3.04-9.64-8.47-10.21-15.93-9.81-15.93-9.81-3.79-1.74-16.31-2.93-24.57,7.1,0,0,0,0,0,0-.26,.22-5.3,5.56-6.46,16.76-1.11,10.68,6.02,24.32,12.79,23.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M586.78,165.72s2.01-17.8-13.79-15.54c-10.32,1.47-16.71,15.46-7.27,21.81,9.44,6.35,21.06-6.27,21.06-6.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M567.31,173.82c-.08,0-.16-.02-.24-.06-.24-.13-.33-.44-.2-.68,3.66-6.65,8.88-9.59,12.61-10.89,4.05-1.4,7.2-1.23,7.33-1.23,.28,.02,.49,.25,.47,.53-.02,.28-.25,.49-.53,.47-.12,0-12.31-.57-19,11.6-.09,.17-.26,.26-.44,.26Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M577.52,205.83s-12.31-6.89-9.89-21.23c2.42-14.34,11.86-22.97,26.33-18.81,0,0-1.4,41.45-16.44,40.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M611.75,179.46s1.26,12.31-.99,14.09c-2.24,1.78-4.44-3.09-4.44-3.09,0,0,3.06-10.87,5.43-11Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M606.09,194.67s3.67-3.22,4.89,.73c1.22,3.95-1.25,11.22-5.82,9.29l.94-10.02Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M610.6,203.79c-.5,.46-1.06,.86-1.67,1.19-2.31,1.24-5.32,1.39-8.94-.51,0,0-4.63-6.02,2.21-16.64,0,0,6.27-1.65,9.86,2.14,.4,.42,.76,.9,1.08,1.46,.2,.34,.37,.71,.53,1.11,1.27,3.23,.09,8.37-3.07,11.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M610.44,188.68c.29-1.42,.58-3.18,.77-5.13-.09,.04-.18,.07-.28,.07-.39,.03-.77-.13-1.15-.41-.17,1.82-.43,3.47-.69,4.84l1.35,.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M610.6,203.79c-.5,.46-1.06,.86-1.67,1.19,3.17-6.57,3.26-12.57,3.13-15.01,.4,.42,.76,.9,1.08,1.46,0,2.76-.42,7.29-2.54,12.36Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M595.38,212.43l-1.51,10.18s-6.23,7.99-20.65-5.04c1.64-4.14,4.16-9.47,3.51-13.55,0,0,1.05,.97,2.87,2.12,.37,.24,.77,.49,1.19,.74,3.75,2.28,9.47,5.19,14.6,5.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M595.38,212.43l-.71,4.76c-4.21-1.62-11.49-5.13-15.08-11.06,.37,.24,.77,.49,1.19,.74,3.75,2.28,9.47,5.19,14.6,5.55Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M609.21,195.12c-.16,1.05-.31,2.04-.47,2.98-1.16,7.02-2.22,10.8-4.17,12.3-9.87,7.57-27.27-5.81-27.83-6.24,0,0-.01-.01-.01-.01-.06-.82-.1-1.63-.12-2.42-.23-6.76,.6-12.88,2.14-18.59,.59-6.17,5.08-11.33,11.15-12.57,6.29-1.28,11.25,2.14,14.32,3.6,4.63,2.22,6.75,8.95,5.45,17.89-.16,1.07-.31,2.1-.46,3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M600.39,203.3c-5.52,0-7.73-5.28-7.75-5.34-.1-.26,.02-.55,.28-.65,.26-.1,.55,.02,.65,.28h0c.1,.23,2.41,5.71,8.43,4.55,.27-.05,.53,.13,.59,.4,.05,.27-.13,.53-.4,.59-.64,.12-1.24,.18-1.8,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M596.15,184.24c1.42-.49,1.13-2.58-.37-2.68-2.55-.16-6.65-.1-6.99,1.96-.5,3.01,4.26,1.76,7.27,.75,.03-.01,.06-.02,.09-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M603.67,185.13c-1.1-1.02,0-2.82,1.42-2.3,2.4,.88,6.13,2.59,5.61,4.61-.75,2.96-4.61-.11-6.96-2.24-.02-.02-.05-.04-.07-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M596.32,205.76c1.01,.25,1.86,.06,1.92,.04,.18-.04,.29-.22,.25-.4-.04-.18-.22-.29-.4-.25h0s-1.67,.37-2.92-.73c-.14-.12-.35-.11-.47,.03-.12,.14-.11,.35,.03,.47,.51,.46,1.08,.7,1.6,.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M599.79,198.9c-.09-.04-.15-.12-.19-.21-.06-.19,.04-.4,.23-.46l2.41-.79-1.43-1.45c-.08-.08-.12-.19-.1-.3l.44-3.99c.02-.2,.2-.35,.41-.32,.2,.02,.35,.2,.32,.4l-.43,3.81,1.72,1.74c.09,.09,.13,.22,.1,.34-.03,.12-.12,.22-.24,.26l-2.97,.98c-.1,.03-.19,.02-.28-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M593.54,195.09c-.12,.83-1.93,1.24-4.03,.93-2.1-.31-3.71-1.24-3.58-2.07,.12-.83,1.93-1.24,4.03-.93,2.1,.31,3.71,1.24,3.58,2.07Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M609.21,196.09c-.16,1.05-.31,2.04-.47,2.98-1.92-.36-3.33-1.23-3.21-2,.12-.78,1.73-1.2,3.68-.98Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M595.59,192.13c-.17,1.14-.82,1.98-1.46,1.89-.64-.09-1.01-1.09-.85-2.23,.17-1.14,.82-1.98,1.46-1.89,.64,.09,1.01,1.09,.85,2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M606.84,193.8c-.17,1.14-.82,1.98-1.46,1.89-.64-.09-1.01-1.09-.85-2.23,.17-1.14,.82-1.98,1.46-1.89,.64,.09,1.01,1.09,.85,2.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M581.13,200.1c-.07,.12-2.08,3.36-4.39,4.06,0,0,0,0,0,0,0,0,0-.01,0-.01-.06-.82-.1-1.63-.12-2.42,.08,0,2.31-.06,4.52-1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M580.22,191.89s-3.64-6.78-7.68-2.48c-3.33,3.55,.27,14.84,6.4,11.82l1.28-9.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M578.47,199.38c-.24-.04-.41-.24-.4-.49,.18-4.7-3.45-6.88-3.6-6.97-.22-.13-.3-.42-.17-.65,.13-.23,.42-.3,.65-.17,.17,.1,4.28,2.55,4.07,7.83-.01,.26-.23,.46-.49,.45-.02,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M574.53,195.89c-.14-.02-.26-.1-.34-.23-.13-.22-.06-.51,.17-.65,.21-.12,2.08-1.2,3.43-.63,.24,.1,.35,.38,.25,.62-.1,.24-.38,.35-.62,.25-.78-.33-2.16,.32-2.58,.57-.1,.06-.21,.08-.31,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M591.49,198.1c-3.56-1.36-5.35-5.36-3.99-8.92,1.36-3.56,5.36-5.35,8.92-3.99,3.56,1.36,5.35,5.36,3.99,8.92-1.36,3.56-5.36,5.35-8.92,3.99Zm4.57-11.97c-3.04-1.16-6.46,.37-7.62,3.41-1.16,3.04,.37,6.46,3.41,7.62,3.04,1.16,6.46-.37,7.62-3.41,1.16-3.04-.37-6.46-3.41-7.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M587.72,190.1c-.06,0-.12-.02-.18-.05-3.74-1.71-7.25-.41-7.29-.39-.26,.1-.55-.03-.65-.29-.1-.26,.03-.55,.29-.65,.16-.06,3.95-1.47,8.07,.42,.25,.12,.36,.42,.25,.67-.09,.19-.28,.3-.49,.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M606.79,199.83c-3.56-1.36-5.35-5.36-3.99-8.92,1.36-3.56,5.36-5.35,8.92-3.99,3.56,1.36,5.35,5.36,3.99,8.92-1.36,3.56-5.36,5.35-8.92,3.99Zm4.57-11.97c-3.04-1.16-6.46,.37-7.62,3.41-1.16,3.04,.37,6.46,3.41,7.62,3.04,1.16,6.46-.37,7.62-3.41,1.16-3.04-.37-6.46-3.41-7.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M600.09,191.18c-.08-.04-.14-.1-.19-.18-.15-.24-.08-.55,.16-.7,.07-.04,1.75-1.07,3.5,.27,.22,.17,.26,.49,.09,.71-.17,.22-.49,.26-.71,.09-1.2-.92-2.34-.22-2.35-.22-.16,.1-.35,.1-.5,.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M603.79,167.96c4.2,1.89,7.5,5.39,8.97,9.75,.92,2.73,1.69,6.34-2.15,5.87-10.48-1.27-16.09-12.15-16.09-12.15,0,0-2.04,10.02-10.27,8.8-8.23-1.23-7.97-7.43-3.29-10.94,3.81-2.86,13.52-5.52,22.83-1.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M584.57,179.08s-4.68,5.03-3,10.44c1.68,5.41,1.79,9.75,.04,12.66,0,0-.45-5.7-2.54-10.02-1.71-3.55-3.31-6.25-2.07-10.34,.85-2.81,2.9-5.51,7.57-2.74Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M576.96,203.62c-3.63,.88-6.44,.37-8.52-.94-.33-.21-.64-.44-.94-.68-4.36-3.65-4.68-11.22-2.01-14.93,.94-1.31,2.03-2.19,3.18-2.75,.35-.18,.7-.32,1.05-.43,4.51-1.48,9.4,1.23,9.4,1.23,5.12,14.08-2.15,18.51-2.15,18.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M589.73,209.78c-10.61-2.17-15.12-9.81-15.33-10.17-.17-.29-.07-.67,.23-.84,.29-.17,.67-.07,.84,.23,.07,.12,5.58,9.38,18.44,10.08,.34,.02,.6,.31,.58,.65-.02,.34-.31,.6-.65,.58-1.46-.08-2.83-.26-4.11-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M597.3,210.14c-.22,1.06-1.26,1.75-2.32,1.53s-1.75-1.26-1.53-2.32c.22-1.06,1.26-1.75,2.32-1.53s1.75,1.26,1.53,2.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M568.45,202.69c-.33-.21-.64-.44-.94-.68,3.36-7.6,2.22-14.24,1.16-17.68,.35-.18,.7-.32,1.05-.43,1.13,3.65,2.36,10.74-1.27,18.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M611.52,174.86c-.89-1.67-1.88-2.78-2.37-3.33-.41-1.19-.85-2.31-1.51-3.35-2.22-3.52-5.73-5.68-10.45-6.41-5.09-.79-9.51,.22-13.13,2.99-1.13,.86-2.13,1.87-3.03,2.95-1.24,1.51-2.27,3.18-3.11,4.85-2.92,5.84-3.62,11.84-3.63,11.92l-1.39-.15c.06-.57,1.63-14.05,10.3-20.69,3.93-3.01,8.71-4.11,14.2-3.26,5.14,.79,8.98,3.17,11.42,7.05,1.42,2.25,2.25,4.81,2.7,7.43Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M558.75,328.76l-4.84-9.2c-1.21-2.29,.48-5.04,3.07-5.02l76.03,.82-2.24,11.78-72.01,1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M629.45,326.17h-68.04c-1.64,0-2.83-1.33-2.64-2.97l4.64-42.04c.18-1.64,1.66-2.97,3.3-2.97h68.04c1.64,0,2.83,1.33,2.64,2.97l-4.64,42.04c-.18,1.64-1.66,2.97-3.3,2.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M560.4,327.98s-.05,0-.07,0c-.31-.04-.54-.33-.5-.64l5.65-45.02c.04-.31,.33-.54,.64-.5,.31,.04,.54,.33,.5,.64l-5.65,45.02c-.04,.29-.28,.5-.57,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M593.5,302.93c-.26,3.38,2.23,6.29,5.55,6.5,3.33,.21,6.24-2.35,6.5-5.73,.26-3.38-2.23-6.29-5.55-6.5-3.33-.21-6.24,2.35-6.5,5.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M629.78,329.83h-68.98c-1.52,0-2.68-1.34-2.48-2.84l.66-4.81h74.03l-.75,5.48c-.17,1.24-1.23,2.16-2.48,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M579.8,316.26l-.5,2.4h2.27s-.25,2.86-.25,2.86h-2.63s-.55,2.61-.55,2.61h-3.01s.55-2.61,.55-2.61h-1.86s-.55,2.61-.55,2.61h-3.01s.55-2.61,.55-2.61h-2.27s.25-2.86,.25-2.86h2.63s.5-2.4,.5-2.4h-2.27s.25-2.86,.25-2.86h2.63s.55-2.61,.55-2.61h3.01s-.55,2.61-.55,2.61h1.86s.55-2.61,.55-2.61h3.01s-.55,2.61-.55,2.61h2.27s-.25,2.86-.25,2.86h-2.63Zm-3.01,0h-1.86s-.5,2.4-.5,2.4h1.86s.5-2.4,.5-2.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M648.53,249.82c0,10.36,8.4,18.77,18.77,18.77s18.77-8.4,18.77-18.77-8.4-18.77-18.77-18.77-18.77,8.4-18.77,18.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "657.7 265.17 647.62 267.3 651.98 258.61 657.7 265.17"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M668.9,245.79c0-.88-.85-1.33-1.9-1.33-1.22,0-2.35,.74-2.95,1.93l-5.05-2.52c1.45-2.72,4.31-4.59,8.85-4.59s7.77,1.87,7.77,5.42c0,4.34-4.54,5.1-4.54,7.29h-5.84c0-3.43,3.66-4.45,3.66-6.18Zm-4.48,10.66c0-1.9,1.53-3.35,3.74-3.35s3.74,1.45,3.74,3.35-1.53,3.4-3.74,3.4-3.74-1.53-3.74-3.4Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M462,356.47s-7.67-12.05-26.28-23c-13.15-7.73-20.81-29.57-20.81-29.57,0,0,25.19,1.1,36.14,16.43,10.95,15.33,10.95,36.14,10.95,36.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M462.08,356.8c-.17,0-.32-.11-.36-.28-3.54-13.37-11.29-23.06-17.17-28.84-6.37-6.26-11.96-9.39-12.02-9.42-.18-.1-.25-.33-.15-.51,.1-.18,.33-.25,.51-.15,.06,.03,5.74,3.21,12.18,9.55,5.95,5.84,13.79,15.65,17.37,29.18,.05,.2-.07,.41-.27,.46-.03,0-.06,.01-.1,.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M458.69,356.2s-2.19-4.38-12.05-3.29c-9.86,1.1-15.33,6.57-32.85-3.29,0,0,13.14-10.95,27.38-8.76,14.24,2.19,15.33,7.67,17.52,15.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M458.74,356.57c-.12,0-.25-.06-.32-.18-.04-.07-4.45-7-11.54-8.29-12.39-2.25-20.83,1.71-20.91,1.75-.19,.09-.41,.01-.5-.18-.09-.19-.01-.41,.18-.5,.09-.04,8.73-4.11,21.37-1.81,7.42,1.35,11.86,8.33,12.04,8.63,.11,.18,.06,.41-.12,.52-.06,.04-.13,.06-.2,.06Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M463,355.14s-.86-4.82,7.7-9.83c8.56-5.01,16.22-3.89,24.39-22.26,0,0-17.08-.94-27.19,9.32-10.11,10.26-7.72,15.31-4.9,22.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M462.96,355.54c-.19,0-.36-.15-.37-.34-.03-.35-.64-8.6,4.51-14.11,8.77-9.39,18.13-11.29,18.22-11.31,.2-.04,.4,.09,.44,.3,.04,.2-.09,.4-.3,.44-.09,.02-9.22,1.88-17.82,11.08-4.92,5.27-4.32,13.46-4.31,13.54,.02,.21-.14,.39-.34,.4-.01,0-.02,0-.03,0Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 446.5,
    y: 354.86,
    width: 29.15,
    height: 6.23,
    rx: 2.57,
    ry: 2.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M461.19,414.72c-19.58,0-32.04-3.12-30.04-16.91,1.27-8.75,8.1-17.33,12.92-22.43,.68-.72,1.32-1.37,1.89-1.94,1.79-1.76,2.99-2.78,2.99-2.78l.06-.32,.34-1.94,.39-2.23,.9-5.09,.31-1.78,10.24-.45,10.68,.45,.24,1.78,.38,2.79,.62,4.52,.27,1.94,.04,.32s1.21,1.02,2.99,2.78c.58,.57,1.22,1.22,1.9,1.94,4.82,5.1,11.65,13.67,12.92,22.43,2,13.79-10.46,16.91-30.04,16.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "473.38 370.35 449.01 370.35 449.35 368.41 473.12 368.41 473.38 370.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M478.31,375.38h-34.25c.68-.72,1.32-1.37,1.89-1.94h30.46c.58,.57,1.22,1.22,1.9,1.94Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "472.5 363.89 449.74 366.18 450.64 361.09 472.11 361.09 472.5 363.89"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 249.76,
    y: 222.8,
    width: 12.56,
    height: 9.69,
    rx: 1.66,
    ry: 1.66
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "265.96 222.8 265.96 232.49 262.04 229.2 262.04 226.09 265.96 222.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 282.82,
    cy: 227.65,
    r: 8.07
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M279.02,232.3c.22,0,.43-.08,.6-.25l7.61-7.61c.33-.33,.33-.87,0-1.2-.33-.33-.87-.33-1.2,0l-7.61,7.61c-.33,.33-.33,.87,0,1.2,.17,.17,.38,.25,.6,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M286.63,232.3c.22,0,.43-.08,.6-.25,.33-.33,.33-.87,0-1.2l-7.61-7.61c-.33-.33-.87-.33-1.2,0-.33,.33-.33,.87,0,1.2l7.61,7.61c.17,.17,.38,.25,.6,.25Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 235.3,
    y: 220.16,
    width: 4.44,
    height: 11.57,
    rx: 1.83,
    ry: 1.83,
    transform: "translate(475.03 451.9) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 237.06,
    y: 229.05,
    width: 0.91,
    height: 5.43,
    rx: 0.38,
    ry: 0.38,
    transform: "translate(475.03 463.53) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 233.06,
    y: 232.99,
    width: 8.92,
    height: 1.91,
    rx: 0.79,
    ry: 0.79,
    transform: "translate(475.03 467.89) rotate(180)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFeatureThree);
export default __webpack_public_path__ + "static/media/home-feature-three.a251844ed108b6e627f88cce56c4ccf2.svg";
export { ForwardRef as ReactComponent };